<template>
  <div class="nk-content-wrap animate-fadein">
     <transition name="fade-slide">
      <div v-if="isLoading" class="global-loader">
        <div class="loader-spinner"></div>
        <p>Loading...</p>
      </div>
    </transition>
    <!-- 🔹 HEADER -->
    <div class="nk-block-head nk-block-head-sm mb-4">
      <div class="d-flex justify-between align-center flex-wrap gap-3">
        <div>
          <h3 class="page-title mb-1">Help Us Shape Your Website</h3>
          <p class="text-muted">
            We need some basic info to build your perfect site.
          </p>
        </div>
        <div class="d-flex gap-2">
          <button class="btn-outline-secondary">
            <i class="bx bx-help-circle"></i> Help
          </button>
         
        </div>
      </div>
    </div>

    <!-- 🔹 POPUP MODAL: CHOOSE WEBSITE MODE -->
  <div v-if="showModeModal" class="mode-modal">
  <div class="mode-modal-content animate-popup">
    <h3 class="modal-title">Choose How You Want to Build</h3>
    <p class="modal-desc">
      Select your preferred mode to start building your website.
    </p>

    <div class="mode-selection-horizontal">
      <!-- Instant Website (Left) -->
      <div class="mode-card selectable" @click="selectMode('instant')">
        <div class="icon-box"><i class="bx bx-bolt-circle"></i></div>
        <h5>Instant Website</h5>
        <p>
          Describe your business in one line — we’ll instantly build a site
          for you.
        </p>
      </div>

      <!-- Detailed Wizard (Right) -->
      <div class="mode-card premium selectable" @click="selectMode('detailed')">
        <div class="icon-box"><i class="bx bx-layer-plus"></i></div>
        <h5>
          Detailed Website <span class="badge-pro">Pro</span>
        </h5>
        <p>
          Go through our 12-step guided wizard for full control and
          customization.
        </p>
      </div>
    </div>
  </div>
</div>


    <!-- 🔹 MAIN SECTION (WIZARD) -->
    <div v-if="!showModeModal" class="main-section" style="margin-top: 2rem;">
      <!-- LEFT SIDEBAR (Visible only in detailed mode) -->
      <aside v-if="mode === 'detailed'" class="step-sidebar animate-slideup">
        <transition-group name="fade-slide" tag="ul" class="step-list">
          <li
            v-for="step in steps"
            :key="step.id"
            :class="['step-item', { active: currentStep === step.id }]"
            @click="gotostep(step.id)"
          >
            <div class="icon"><i :class="step.icon"></i></div>
            <div class="step-text">
              <h5>{{ step.title }}</h5>
              <p>{{ step.desc }}</p>
            </div>
          </li>
        </transition-group>
      </aside>

      <!-- RIGHT PANEL -->
      <div class="main-body card animate-slideup">
        <transition name="fade-slide" mode="out-in">
          <!-- Step 1: Business Info -->
         <div v-if="currentStep === 'business'" key="business">
  <h3><i class="bx bx-buildings"></i> Business Information</h3>
  <p class="step-desc" style="margin-top: 1rem;">
    Let’s start with the basic details so we can personalize your website experience.
  </p>

  <div class="form-grid" style="margin-top: 1rem;">
    <!-- 🔹 Business Name -->
    <div class="form-group half">
      <label>Business Name</label>
      <input
        v-model="websiteData.website_buss_name"
        type="text"
        placeholder="e.g. July Toss"
      />
    </div>

    <!-- 🔹 Business Category -->
    <div class="form-group half">
      <label>Category</label>
      <select v-model="websiteData.website_buss_cat">
        <option value="">Select Category</option>
        <option value="Services">Services</option>
        <option value="Construction">Construction</option>
        <option value="Retail">Retail</option>
        <option value="Hospitality">Hospitality</option>
        <option value="Healthcare">Healthcare</option>
        <option value="Education">Education</option>
        <option value="Technology">Technology</option>
        <option value="Manufacturing">Manufacturing</option>
        <option value="RealEstate">RealEstate</option>
        <option value="Logistics">Logistics</option>
        <option value="Lifestyle">Lifestyle</option>
        <option value="Finance">Finance</option>
        <option value="Creative">Creative</option>
        <option value="Travel">Travel</option>
        <option value="NonProfit">NonProfit</option>
        <option value="Other">Other</option>
      </select>
    </div>

    <!-- 🔹 Region / City -->
    <div class="form-group">
      <label>Description</label>
      <textarea
            v-model="websiteData.website_about_section"
            rows="4"
            placeholder="Write about your business..."
          ></textarea>
    </div>

  </div>
</div>


          <!-- === STEP 2: BRANDING === -->
         <div v-else-if="currentStep === 'branding'" key="branding">
          <h3><i class="bx bx-palette"></i> Branding</h3>
          <p class="step-desc" style="margin-top: 1rem;">
            Customize your visuals, color scheme, and brand identity.
          </p>

          <div class="form-grid" style="margin-top: 1rem;">
            <!-- 🔹 Upload Logo -->
            <div class="form-group half">
              <label>Upload Logo</label>
              <div class="upload-box" @click="triggerFilePicker">
          <input
            type="file"
            ref="fileInput"
            style="display: none;"
            accept="image/*"
            @change="chFile"
          />

          <i class="bx bx-image-add"></i>

          <span v-if="!websiteData.website_logo">Upload your logo</span>

          <img
            v-if="websiteData.website_logo"
            :src="apiBaseUrl+websiteData.website_logo"
            alt="Logo Preview"
            style="max-height: 50px; display: block; margin-top: 6px;"
          />
        </div>

    </div>
     <div class="form-group half">
              <label>Upload Favicon</label>
              <div class="upload-box" @click="triggerFilePicker1">
          <input
            type="file"
            ref="fileInput1"
            style="display: none;"
            accept="image/*"
            @change="chFile1"
          />

          <i class="bx bx-image-add"></i>

          <span v-if="!websiteData.website_fav">Upload your favicon</span>

          <img
            v-if="websiteData.website_fav"
            :src="apiBaseUrl+websiteData.website_fav"
            alt="Logo Preview"
            style="max-height: 50px; display: block; margin-top: 6px;"
          />
        </div>

    </div>

    <!-- 🔹 Primary Brand Color -->
    <div class="form-group half">
      <label>Primary Brand Color</label>
      <div class="color-card animate-fadein">
        <div class="color-header">
          <div
            class="color-preview"
            :style="{ backgroundColor: websiteData.website_color }"
          >
            <input
              type="color"
              v-model="websiteData.website_color"
              class="color-input"
            />
            <i class="bx bx-droplet"></i>
          </div>
          <div class="color-meta">
            <h5>{{ colorName }}</h5>
            <span>{{ websiteData.website_color.toUpperCase() }}</span>
          </div>
        </div>

        <div class="color-palette">
          <div
            v-for="(color, i) in presetColors"
            :key="i"
            class="color-swatch"
            :style="{ backgroundColor: color }"
            @click="websiteData.website_color = color"
            :title="color"
          ></div>
        </div>
      </div>
    </div>

    <!-- 🔹 Font Style -->
    <div class="form-group half">
      <label>Font Style</label>
      <select v-model="websiteData.website_font">
        <option value="">Select Font</option>
        <option value="Inter">Inter</option>
        <option value="Plus Jakarta Sans">Plus Jakarta Sans</option>
        <option value="Poppins">Poppins</option>
        <option value="Roboto">Roboto</option>
        <option value="Montserrat">Montserrat</option>
        <option value="DM Sans">DM Sans</option>
        <option value="Manrope">Manrope</option>
        <option value="Nunito Sans">Nunito Sans</option>
        <option value="Open Sans">Open Sans</option>
        <option value="Source Sans 3">Source Sans 3</option>

      </select>
    </div>

  </div>
</div>

          <!-- === STEP 3: LAYOUT SELECTION === -->
        <!-- === STEP 3: LAYOUT SELECTION (Enhanced) === -->
  <div v-else-if="currentStep === 'layout'" key="layout">
    <h3><i class="bx bx-layout"></i> Choose Your Layout</h3>
    <p class="step-desc" style="margin-top: 1rem;">
      Select a layout that fits your business vision. You can always refine it later.
    </p>

    <!-- 🔹 Filter Controls -->
    <div class="layout-filters-bar" style="margin-top: 1rem;">
      <div class="form-group">
        <label>Category</label>
        <select v-model="websiteData.website_layout_category">
          <option value="">All</option>
          <option>Local Service</option>
          <option>Agency</option>
          <option>Freelancer</option>
          <option>E-Commerce</option>
        </select>
      </div>

      <div class="form-group">
        <label>Layout Type</label>
        <select v-model="websiteData.website_layout_type">
          <option value="">All</option>
          <option>One Page</option>
          <option>Multi Page</option>
          <option>Landing Page</option>
        </select>
      </div>

      <div class="search-box">
        <i class="bx bx-search"></i>
        <input
          v-model="websiteData.website_layout_search"
          type="text"
          placeholder="Search layouts..."
        />
      </div>
  </div>

  <!-- 🔹 Template Grid -->
  <transition-group name="fade-smooth" tag="div" class="template-grid">
    <div
      v-for="template in paginatedTemplates"
      :key="template.id"
      class="template-card"
      :class="{ active: websiteData.website_layout === template.id }"
      @click="websiteData.website_layout = template.id"
    >
      <div class="template-thumb">
        <img :src="template.image" alt="Template Preview" />
        <div v-if="template.aiRecommended" class="ai-badge animate-bounce">
          <i class="bx bx-brain"></i> AI Recommended
        </div>
      </div>
      <div class="template-info">
        <h4>{{ template.name }}</h4>
        <p>{{ template.desc }}</p>
      </div>
    </div>
  </transition-group>

  <!-- 🔹 Pagination -->
  <div class="pagination-bar" v-if="filteredTemplates.length > perPage">
    <button
      class="page-btn"
      :disabled="currentPage === 1"
      @click="currentPage--"
    >
      <i class="bx bx-chevron-left"></i>
    </button>

    <span class="page-info">
      Page {{ currentPage }} of {{ totalPages }}
    </span>

    <button
      class="page-btn"
      :disabled="currentPage === totalPages"
      @click="currentPage++"
    >
      <i class="bx bx-chevron-right"></i>
    </button>
  </div>

  <!-- 🔹 Live Preview -->
  <transition name="fade-smooth">
    <div
      v-if="websiteData.website_layout"
      class="template-preview animate-slideup"
    >
      <h4><i class="bx bx-desktop"></i> Live Preview</h4>
      <iframe
        :src="`https://preview.aibuilder.app/templates/${websiteData.website_layout}`"
        frameborder="0"
        class="preview-frame"
      ></iframe>
    </div>
  </transition>
</div>


        <!-- === STEP 4: CONTENT === -->
       <div v-else-if="currentStep === 'content'" key="content">
        <h3><i class="bx bx-edit-alt"></i> Booking Calender</h3>
        <p class="step-desc" style="margin-top: 1rem;">
          Schedule appointments instantly with ease
        </p>

  <!-- === Generated or Editable Content Fields === -->
  <transition name="fade-smooth">
    <div class="content-editor animate-slideup" style="margin-top: 1rem;">
      <div class="form-grid">
        <div class="form-group full">
          <label>Calender Link</label>
          <!-- <input
            v-model="websiteData.website_headline"
            type="text"
            placeholder="e.g. Paste Your Calander Link Here"
          /> -->
          <select v-model="websiteData.website_headline">
            <option value="">Not needed</option>
            <option  v-for="step in cals"
            :key="step.booking_page_id" :value="mainBaseUrl+'appointment/embed/'+step.booking_page_url">{{mainBaseUrl}}appointment/embed/{{ step.booking_page_url }}</option>
          </select>
          
        </div>
      </div>

      <div class="preview-box">
        <h4>Live Preview</h4>
        <div>
          <iframe :src="websiteData.website_headline" class="calendar-iframe"></iframe>
        </div>
      </div>
    </div>
  </transition>
</div>


        <!-- === STEP: MEDIA === -->
  <div v-else-if="currentStep === 'media'" key="media">
    <h3><i class="bx bx-receipt"></i> Pricing Plans</h3>
    <p class="step-desc" style="margin-top: 1rem;">
      Create 1–3 pricing plans for your website.
    </p>

   

    <!-- 🧩 LAYOUT SELECT -->
    <div class="form-group" style="margin-top: 1rem;">
      <label>Plan Layout</label>
      <select v-model="pricing.layout">
        <option value="">-- Select Layout --</option>
        <option value="1">Single Plan</option>
        <option value="2">Two Plans</option>
        <option value="3">Three Plans</option>
      </select>
    </div>

    <!-- 💰 PRICING PLAN BUILDER -->
    <div
      v-if="pricing.layout"
      class="plans-builder"
      :class="'layout-' + pricing.layout"
      style="margin-top: 20px; display: flex; gap: 20px;"
    >
      <div
        v-for="(plan, i) in pricing.forms.slice(0, Number(pricing.layout))"
        :key="i"
        class="plan-box"
        style="
          flex: 1;
          border: 1px solid var(--border);
          border-radius: var(--radius);
          padding: 18px;
          background: var(--card);
        "
      >
        <h4 style="margin-bottom: 14px;">Plan {{ i + 1 }}</h4>

        <!-- 🔹 TITLE -->
        <div class="form-group">
          <label>Plan Title</label>
          <input v-model="plan.title" placeholder="Basic / Pro / Starter..." />
        </div>

        <!-- 🔹 PRICE -->
        <div class="form-group">
          <label>Price</label>
          <input v-model="plan.price" type="number" placeholder="2000" />
        </div>

        <!-- 🔹 TYPE -->
        <div class="form-group">
          <label>Type</label>
          <select v-model="plan.type">
            <option>Monthly</option>
            <option>Yearly</option>
          </select>
        </div>

        <!-- 🔹 CURRENCY -->
        <div class="form-group">
          <label>Currency</label>
          <select v-model="plan.curr">
            <option value="USD">USD</option>
          </select>
        </div>

        <!-- 🔹 STATUS -->
        <div class="form-group">
          <label>Status</label>
          <select v-model="plan.status">
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        <!-- 🔹 DESCRIPTION -->
        <div class="form-group">
          <label>Description</label>
          <textarea
            rows="3"
            v-model="plan.desc"
            placeholder="Short description..."
          ></textarea>
        </div>

        <!-- 🔹 FEATURES -->
        <div class="form-group">
          <label>Features</label>

          <div class="features-list">
            <div
              v-for="(ft, fi) in plan.features"
              :key="fi"
              class="feature-item"
              style="display: flex; gap: 6px; align-items: center;"
            >
              <input
                type="text"
                v-model="plan.features[fi]"
                placeholder="Feature name"
              />
              <button
                class="btn-delete-sm"
                type="button"
                @click="removeFeatureWizard(i, fi)"
              >
                <i class="bx bx-x"></i>
              </button>
            </div>

            <button
              class="btn-add-feature"
              type="button"
              @click="addFeatureWizard(i)"
            >
              <i class="bx bx-plus"></i> Add Feature
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div v-else-if="currentStep === 'seo'" key="seo">
    <h3><i class="bx bx-line-chart"></i> SEO Optimization</h3>
    <p class="step-desc" style="margin-top: 1rem;">
      Optimize your website for better visibility. Generate meta tags, keywords, and check SEO performance.
    </p>

    <!-- === AI Meta Generator === -->
    <div class="ai-seo-box" style="margin-top: 1rem;">
      <div class="ai-seo-header">
        <h4><i class="bx bx-brain"></i> AI SEO Generator</h4>
        <p>
          Let AI suggest keywords and meta descriptions based on your business name and category.
        </p>
      </div>

      <div class="ai-input-row">
        <input
          v-model="websiteData.website_seo_query"
          type="text"
          placeholder="Enter your business or topic..."
        />
        <button class="btn-ai-generate" @click="generateSEO">
          <i class="bx bx-magic-wand"></i> Generate
        </button>
      </div>

      <transition name="fade-smooth">
        <div v-if="websiteData.website_ai_description" class="ai-output">
          <p><strong>Suggested Description:</strong> {{ websiteData.website_ai_description }}</p>
        </div>
      </transition>
    </div>

    <!-- === SEO Meta Form === -->
    <div class="seo-meta-form">
      <div class="form-group">
        <label>Page Title</label>
        <input
          v-model="websiteData.website_seo_title"
          placeholder="Enter SEO title (50–60 chars)"
        />
      </div>

      <div class="form-group">
        <label>Meta Description</label>
        <textarea
          v-model="websiteData.website_seo_desc"
          rows="3"
          placeholder="Enter meta description (120–160 chars)"
        ></textarea>
      </div>

      <div class="form-group">
        <label>Keywords</label>
        <input
          v-model="websiteData.website_seo_keyowrds"
          placeholder="Press Enter to add keyword"
        />
        <div class="keyword-list">
          <span
            v-for="(k, i) in websiteData.website_seo_keywords"
            :key="i"
            class="keyword-tag"
          >
            {{ k }}
            <i class="bx bx-x" @click="websiteData.website_seo_keywords.splice(i, 1)"></i>
          </span>
        </div>
      </div>

      <div class="form-group">
        <label>Canonical URL</label>
        <input
          v-model="websiteData.website_seo_conical_url"
          placeholder="https://yourdomain.com/page"
        />
      </div>

      <div class="form-group">
        <label>Open Graph Image</label>
        <div class="upload-box" @click="triggerUpload">
          <input
            ref="fileInput"
            type="file"
            accept="image/*"
            style="display: none"
            @change="handleFileUpload"
          />
          <i class="bx bx-image-add"></i>
          <span v-if="!websiteData.website_seo_og_image">
            Upload an image for social sharing
          </span>
          <img
            v-if="websiteData.website_seo_og_image"
            :src="websiteData.website_seo_og_image"
            class="preview-image"
          />
        </div>
      </div>
    </div>

    <!-- === SEO Health Checker === -->
    <div class="seo-health">
      <h4><i class="bx bx-check-shield"></i> SEO Health Summary</h4>
      <ul class="seo-checklist">
        <li
          :class="{
            success:
              websiteData.website_seo_title &&
              websiteData.website_seo_title.length >= 50 &&
              websiteData.website_seo_title.length <= 60
          }"
        >
          <i class="bx bx-check"></i> Title length is optimal
        </li>
        <li
          :class="{
            success:
              websiteData.website_seo_desc &&
              websiteData.website_seo_desc.length >= 120 &&
              websiteData.website_seo_desc.length <= 160
          }"
        >
          <i class="bx bx-check"></i> Meta description length is ideal
        </li>
        <li
          :class="{ success: websiteData.website_seo_keywords.length >= 3 }"
        >
          <i class="bx bx-check"></i> At least 3 keywords added
        </li>
        <li :class="{ success: websiteData.website_seo_og_image }">
          <i class="bx bx-check"></i> Open Graph image set
        </li>
      </ul>
    </div>
  </div>


        <!-- === CHATBOT SETUP TAB === -->
       <div v-else-if="currentStep === 'chat'" key="chat">
  <h3><i class="bx bx-bot"></i> AI Chat Bot Setup</h3>
  <p class="step-desc" style="margin-top: 1rem;">
    Configure your AI chatbot to assist website visitors. Customize its style, train it with your content, and preview it live.
  </p>

  <!-- === Chatbot Appearance Customization === -->
  <div class="chatbot-section" style="margin-top: 1rem;">
    <h4><i class="bx bx-customize"></i> Chatbot Customization</h4>
    <div class="form-grid">
      <div class="form-group half">
        <label>Bot Name</label>
        <input
          v-model="websiteData.website_chatbot_name"
          type="text"
          placeholder="e.g. July Toss Assistant"
        />
      </div>
<!-- 
      <div class="form-group half">
        <label>Accent Color</label>
        <input v-model="websiteData.website_chatbot_color" type="color" />
      </div> -->

      <div class="form-group half">
        <label>Avatar</label>
        <div class="upload-box" @click="triggerFileUpload('avatar')">
          <i class="bx bx-image-add"></i>
          <span v-if="!websiteData.website_chatbot_avtar">
            Upload Avatar Image
          </span>
          <img
            v-if="websiteData.website_chatbot_avtar"
            :src="apiBaseUrl+websiteData.website_chatbot_avtar"
            class="bot-avatar-preview"
          />
          <input
            ref="avatarInput"
            type="file"
            accept="image/*"
            style="display: none"
            @change="handleFileUpload($event, 'avatar')"
          />
        </div>
      </div>

      <div class="form-group half">
        <label>Welcome Message</label>
        <input
          v-model="websiteData.website_chatbot_msg"
          type="text"
          placeholder="e.g. Hi there! How can I help you today?"
        />
      </div>
    </div>
  </div>

  <!-- === Training Data Upload === -->
  <div class="chatbot-section">
    <h4><i class="bx bx-upload"></i> Training Data</h4>
    <p class="text-muted">
      Upload documents, FAQs, or data that your chatbot should learn from. Supported formats: TXT, PDF, CSV.
    </p>

    <div class="upload-box" @click="triggerFileUpload('training')">
      <i class="bx bx-cloud-upload"></i>
      <span>Click or drag to upload training data</span>
      <input
        ref="trainingInput"
        type="file"
        accept=".txt,.pdf,.csv"
        multiple
        style="display: none"
        @change="handleFileUpload($event, 'training')"
      />
    </div>

    <transition-group name="fade-smooth" tag="div" class="training-files">
      <div
        v-if="websiteData.website_chatbot_trianing_data && websiteData.website_chatbot_trianing_data!='[]'"
        :key="index"
        class="training-file"
      >
        <i class="bx bx-file"></i>
        <span>{{ websiteData.website_chatbot_trianing_data }}</span>
        <button
          class="remove-btn"
          @click="websiteData.website_chatbot_trianing_data=''"
        >
          <i class="bx bx-x"></i>
        </button>
      </div>
    </transition-group>
  </div>

  <!-- === Chatbot Preview === -->
  <div class="chatbot-section">
    <h4><i class="bx bx-message-dots"></i> Live Chat Preview</h4>
    <div class="chatbot-preview">
      <div class="chat-window">
        <div
          class="chat-header"
          :style="{ background: websiteData.website_chatbot_color }"
        >
          <img
            v-if="websiteData.website_chatbot_avtar"
            :src="apiBaseUrl+websiteData.website_chatbot_avtar"
            alt="Bot Avatar"
            class="bot-avatar"
          />
          <h5>{{ websiteData.website_chatbot_name || "July Toss Assistant" }}</h5>
        </div>

        <div class="chat-messages">
          <div class="bot-message">
            <div class="avatar">
              <img
                :src="apiBaseUrl+websiteData.website_chatbot_avtar || '/default-bot.png'"
              />
            </div>
            <div class="message">
              {{
                websiteData.website_chatbot_msg ||
                "Hi there! I'm your AI Assistant. How can I help you today?"
              }}
            </div>
          </div>

          <div class="user-message">
            <div class="message">Can you tell me about your services?</div>
          </div>
        </div>

        <div class="chat-input">
          <input type="text" placeholder="Type your message..." disabled />
          <button
            :style="{ background: websiteData.website_chatbot_color }"
          >
            <i class="bx bx-send"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>


        <!-- === DOMAIN TAB === -->
        <div v-else-if="currentStep === 'domain'" key="domain">
  <h3><i class="bx bx-globe"></i> Domain Settings</h3>
  <p class="step-desc" style="margin-top: 1rem;">
    Connect your custom domain or use a free subdomain to publish your website.
    We’ll automatically generate DNS records and SSL certificates.
  </p>

  <!-- === Domain Type Options === -->
  <div class="domain-options" style="margin-top: 1rem;">
    <div
      class="domain-card"
      :class="{ active: websiteData.website_domain_type === 'custom' }"
      @click="websiteData.website_domain_type = 'custom'"
    >
      <i class="bx bx-world"></i>
      <div>
        <h4>Connect Custom Domain</h4>
        <p>Use your own domain (e.g. <strong>yourbrand.com</strong>)</p>
      </div>
    </div>

    <div
      class="domain-card"
      :class="{ active: websiteData.website_domain_type === 'subdomain' }"
      @click="websiteData.website_domain_type = 'subdomain'"
    >
      <i class="bx bx-link-alt"></i>
      <div>
        <h4>Use Free Subdomain</h4>
        <p>Instantly publish with a free <strong>aiweb.app</strong> domain</p>
      </div>
    </div>
  </div>

  <!-- === Custom Domain Form === -->
  <transition name="fade-smooth">
    <div
      v-if="websiteData.website_domain_type === 'custom'"
      class="domain-form animate-slideup"
    >
      <h5><i class="bx bx-lock"></i> Connect Your Domain</h5>
      <p class="text-muted">Point your DNS to our servers and verify ownership.</p>

      <div class="form-group">
        <label>Enter Domain Name</label>
        <input
          v-model="websiteData.website_domain"
          type="text"
          placeholder="e.g. www.yourbrand.com"
        />
      </div>

      <!-- === DNS Record Info === -->
      <div class="dns-info">
        <h6><i class="bx bx-cog"></i> Required DNS Records</h6>
        <ul style="list-style:none; padding:0; margin:0; font-size:16px;">
          <li style="
              display:flex; 
              align-items:center; 
              gap:10px; 
              padding:10px 12px; 
              border:1px solid #ddd; 
              border-radius:6px; 
              margin-bottom:10px;
              background:#fafafa;
            ">
            <strong style="min-width:90px; color:#333;">A Record:</strong>
            <span style="min-width:60px; display:inline-block; font-weight:600;">{{ chkAt() }}</span>
            <span style="font-weight:600; color:#007bff;">192.169.144.1</span>
          </li>

          <li style="
              display:flex; 
              align-items:center; 
              gap:10px; 
              padding:10px 12px; 
              border:1px solid #ddd; 
              border-radius:6px; 
              background:#fafafa;
            ">
            <strong style="min-width:90px; color:#333;">CNAME:</strong>
            <span style="min-width:60px; display:inline-block; font-weight:600;">www</span>
            <span style="font-weight:600; color:#28a745;">{{ websiteData.website_domain }}</span>
          </li>
        </ul>

      </div>

      <!-- === SSL & HTTPS === -->
      <div
        class="form-group switch-row"
        style="
          display: flex;
          justify-content: space-between;
          align-items: start;
          margin-top: 1rem;
          gap: 0.5rem;
        "
      >
        <label style="font-weight: 600; color: #374151; font-size: 0.9rem;">
          Auto SSL Certificate
        </label>

        <label
          class="switch"
          style="
            position: relative;
            display: inline-block;
            width: 44px;
            height: 24px;
            flex-shrink: 0;
          "
        >
          <input
            type="checkbox"
            v-model="websiteData.website_auto_ssl"
            style="opacity: 0; width: 0; height: 0;"
          />
          <span
            class="slider"
            style="
              position: absolute;
              cursor: pointer;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background-color: #d1d5db;
              transition: 0.4s;
              border-radius: 24px;
            "
          ></span>
        </label>
      </div>

      <!-- === Connection Tester === -->
      <div class="verify-domain">
        <button class="btn-primary" @click="verifyDomain">
          <i class="bx bx-check-circle"></i>
          Verify Domain
        </button>
        <div class="domain-status" :class="domainStatusClass">
          <i :class="domainStatusIcon"></i>
          {{ domainStatusMessage }}
        </div>
      </div>
    </div>
  </transition>

  <!-- === Free Subdomain Form === -->
  <transition name="fade-smooth">
    <div
      v-if="websiteData.website_domain_type === 'subdomain'"
      class="domain-form animate-slideup"
    >
      <h5><i class="bx bx-network-chart"></i> Choose Your Free Subdomain</h5>
      <p class="text-muted">
        Your website will be available immediately at this address.
      </p>

      <div class="form-group">
        <label>Subdomain</label>
        <div class="subdomain-box">
          <span>{{ apiBaseUrl }}</span>
          <input
            v-model="websiteData.website_domain"
            type="text"
            placeholder="yourname"
          />
        </div>
      </div>

      <!-- <div class="verify-domain">
        <button class="btn-primary" @click="reserveSubdomain">
          <i class="bx bx-rocket"></i> Reserve Subdomain
        </button>
        <div class="domain-status" :class="domainStatusClass">
          <i :class="domainStatusIcon"></i>
          {{ domainStatusMessage }}
        </div>
      </div> -->
    </div>
  </transition>

  <!-- === Connection Summary === -->
  <transition name="fade-smooth">
    <div v-if="connectionVerified" class="domain-summary animate-slideup">
      <h4><i class="bx bx-check-shield"></i> Connection Established</h4>
      <p>Your site is now accessible via:</p>
      <div class="live-domain">
        <i class="bx bx-globe"></i>
        <a :href="websiteData.website_domain" target="_blank">{{
          websiteData.website_domain
        }}</a>
      </div>
    </div>
  </transition>
</div>


        <!-- === LAUNCH TAB === -->
       <div v-else-if="currentStep === 'publish'" key="publish">
  <h3><i class="bx bx-rocket"></i> Review & Launch</h3>
  <p class="step-desc" style="margin-top: 1rem;">
    You're all set! Review your details, preview your site, and publish it live.
  </p>

  <!-- === Launch Summary Cards === -->
  <div class="launch-summary" style="margin-top: 1rem;">

    <!-- 🔹 Business Info -->
    <div class="launch-card">
      <i class="bx bx-buildings"></i>
      <div>
        <h4>Business Info</h4>
        <ul>
          <li><strong>Name:</strong> {{ websiteData.website_buss_name || '—' }}</li>
          <li><strong>Category:</strong> {{ websiteData.website_category || '—' }}</li>
          <li><strong>Details:</strong> {{ websiteData.website_about_section || '—' }}</li>
          
        </ul>
      </div>
    </div>

    <!-- 🔹 Branding -->
    <div class="launch-card">
      <i class="bx bx-palette"></i>
      <div>
        <h4>Branding</h4>
        <ul>
          <li>
            <strong>Favicon:</strong>
            <span v-if="websiteData.website_fav">
              <img :src="apiBaseUrl+websiteData.website_fav" alt="Logo" style="height:30px; margin-left:5px;" />
            </span>
            <span v-else>—</span>
          </li>
          <li>
            <strong>Logo:</strong>
            <span v-if="websiteData.website_logo">
              <img :src="apiBaseUrl+websiteData.website_logo" alt="Logo" style="height:30px; margin-left:5px;" />
            </span>
            <span v-else>—</span>
          </li>
          <li><strong>Primary Color:</strong> {{ websiteData.website_color || '#111827' }}</li>
          <li><strong>Font:</strong> {{ websiteData.website_font || 'Plus Jakarta Sans' }}</li>
        </ul>
      </div>
    </div>

    

    <!-- 🔹 Content -->
    <div class="launch-card">
      <i class="bx bx-edit"></i>
      <div>
        <h4>Booking Calander</h4>
        <ul>
          <li><strong>Calander Link:</strong> /{{
      websiteData.website_headline
        ? websiteData.website_headline.split('/').pop()
        : '—'
    }}</li>
        </ul>
      </div>
    </div>

    <!-- 🔹 Media -->
    <div class="launch-card">
      <i class="bx bx-image"></i>
      <div>
        <h4>Pricing Plans</h4>
        <ul>
          <li>
            <strong>Layout:</strong>
            <span v-if="websiteData.website_images?.length">
              {{ websiteData.website_images.length }} uploaded
            </span>
            <span v-else>—</span>
          </li>
          <li>
            <strong>Plans:</strong>
            <span v-if="pricing.layout">
              {{ pricing.forms.length || 'Attached Video' }}
            </span>
            <span v-else>—</span>
          </li>
        </ul>
      </div>
    </div>

    

    <!-- 🔹 Chat Bot -->
    <div class="launch-card">
      <i class="bx bx-bot"></i>
      <div>
        <h4>Chat Bot</h4>
        <ul>
          <li><strong>Name:</strong> {{ websiteData.website_chatbot_name || '—' }}</li>
          <li><strong>Accent Color:</strong> {{ websiteData.website_chatbot_color || '#111827' }}</li>
          <li><strong>Welcome Message:</strong> {{ websiteData.website_chatbot_msg || 'Hi there!' }}</li>
          <li>
            <strong>Avatar:</strong>
            <span v-if="websiteData.website_chatbot_avtar">
              <img :src="apiBaseUrl+websiteData.website_chatbot_avtar" alt="Bot Avatar" style="height:30px; margin-left:5px;" />
            </span>
            <span v-else>—</span>
          </li>
          <li v-if="websiteData.website_chatbot_trianing_data.length>0"><strong>Training Files:</strong> 
            1 uploaded
          </li>
        </ul>
      </div>
    </div>

    <!-- 🔹 Domain -->
    <div class="launch-card">
      <i class="bx bx-globe"></i>
      <div>
        <h4>Domain</h4>
        <ul>
          <li><strong>Type:</strong> {{ websiteData.website_domain_type || '—' }}</li>
          <li>
            <strong>URL:</strong>
            <a v-if="websiteData.website_domain"
              :href="websiteData.website_domain.startsWith('http') ? websiteData.website_domain : `https://${websiteData.website_domain}`"
              target="_blank">
              {{ websiteData.website_domain }}
            </a>
            <span v-else>—</span>
          </li>
          <!-- <li><strong>SSL Enabled:</strong> {{ websiteData.website_enable_ssl ? 'Yes' : 'No' }}</li> -->
        </ul>
      </div>
    </div>
  </div>

</div>




        </transition>

      <!-- 🔹 Footer Navigation -->
<div
  class="action-footer"
  v-if="(mode === 'instant' && currentStep !== 'domain') || (mode === 'detailed' && currentStep !== 'publish')"
>
  <button
    class="btn-secondary"
    v-if="currentStep !== 'business'"
    @click="handleBack"
  >
    <i class="bx bx-chevron-left"></i> Back
  </button>

  <button class="btn-primary" @click="handleNext">
    <i class="bx bx-right-arrow-alt"></i> Next Step
  </button>
</div>

<!-- 🔹 Launch Actions (Final Step for both modes) -->
<div
  class="launch-actions"
  v-if="(mode === 'instant' && currentStep === 'domain') || (mode === 'detailed' && currentStep === 'publish')"
>
  <button class="btn-secondary" @click="handleBack">
    <i class="bx bx-chevron-left"></i> Back
  </button>

  <button
  class="btn-primary launch-btn"
  @click="publishWebsite"
  :disabled="isPublishing"
>
  <i v-if="!isPublishing" class="bx bx-rocket"></i>
  <div v-else class="loader-spinner"></div>
  {{ isPublishing ? 'Publishing...' : 'Publish Website' }}
</button>

</div>

      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, watchEffect, nextTick,onMounted } from "vue";
import { getBookPages } from "@/apis/bookpageapis";
import { createWebsite } from "@/apis/webapis";
import { uploadFile } from "@/apis/invoiceapis";
import { apiBaseUrl,mainBaseUrl } from "@/apis/appconst";
import { useToast } from "vue-toastification";
import { validateField } from "@/other/validator";
const toast = useToast();
const isPublishing = ref(false);
const cals = ref([]);

const gotostep = (sid)=>{
  if(websiteData.value.website_id.length>0){
    currentStep.value = sid
  }
}

const addFeatureWizard = (planIndex) => {
  pricing.value.forms[planIndex].features.push("");
};

const removeFeatureWizard = (planIndex, featureIndex) => {
  if (pricing.value.forms[planIndex].features.length > 1) {
    pricing.value.forms[planIndex].features.splice(featureIndex, 1);
  }
};

 const fetchPages = async () => {
      // const toast = useToast();
      try {
        const ldata = JSON.parse(sessionStorage.getItem("ldata"));
        const res = await getBookPages(
          ldata.user_id,
          "none",
          "",
          "",
          ""
        );
        if (res.status && res.records?.length) {
          cals.value = res.records;
        } else {
          cals.value = [];
          // toast.success(res.success || "No pages found");
        }
      } catch (error) {
        console.error("fetchPages error:", error);
        // toast.error("Failed to load pages");
      }
    };

onMounted(async () => {
  fetchPages();
  if (sessionStorage.getItem("website_id")) {
    try {
      const dbData = JSON.parse(sessionStorage.getItem("website_id"));
      console.log("mont",dbData);
      if (dbData) {
        selectMode(dbData.website_type+"");
        if(dbData.plans &&  dbData.plans.length){
        pricing.value.forms = Array.isArray(dbData.plans)
              ? dbData.plans.map(p => ({
                  title: p.website_plan_title || "",
                  price: p.website_plan_price || "",
                  desc: p.website_plan_desc || "",
                  type: p.website_plan_type || "Monthly",
                  curr: p.website_plan_curr || "USD",
                  status: p.website_plan_status || "active",
                  features: p.website_plan_features.split(",")
                }))
              : [];


          pricing.value.layout = dbData.plans[0].website_plan_type1;
        }
        websiteData.value.website_id = dbData.website_id || null;
        websiteData.value.website_title = dbData.website_title || "";
        websiteData.value.website_mode = dbData.website_type || "";
        websiteData.value.website_desc = dbData.website_desc || "";
        websiteData.value.website_buss_name = dbData.website_buss_name || "";
        websiteData.value.website_buss_cat = dbData.website_buss_cat || "";
        websiteData.value.website_buss_region = dbData.website_buss_region || "";
        websiteData.value.website_buss_timezone = dbData.website_buss_timezone || "";

        websiteData.value.website_logo = dbData.website_logo || "";
        websiteData.value.website_fav = dbData.website_fav || "";
        websiteData.value.website_color = dbData.website_color || "#111827";
        websiteData.value.website_font = dbData.website_font || "Inter";
        websiteData.value.website_tone = "Professional";

        websiteData.value.website_layout = dbData.website_layout || "";
        websiteData.value.website_headline = dbData.website_headline || "";
        websiteData.value.website_subheadline = dbData.website_subheadline || "";
        websiteData.value.website_about_section = dbData.website_about_section || "";
        websiteData.value.website_call_to_action = dbData.website_call_to_action || "";
        websiteData.value.website_cta_link = dbData.website_cta_link || "";

        websiteData.value.website_promo_viedo = dbData.website_promo_viedo || "";
        websiteData.value.website_images = dbData.website_images.length>0?JSON.parse(dbData.website_images):[] || [];

        websiteData.value.website_seo_title = dbData.website_seo_title || "";
        websiteData.value.website_seo_desc = dbData.website_seo_desc || "";
        websiteData.value.website_seo_keyowrds = dbData.website_seo_keyowrds || "";
        websiteData.value.website_seo_conical_url = dbData.website_seo_conical_url || "";
        websiteData.value.website_seo_graph_image = dbData.website_seo_graph_image || "";

        websiteData.value.website_is_chatbot = dbData.website_is_chatbot ?? true;
        websiteData.value.website_chatbot_name = dbData.website_chatbot_name || "July Toss Assistant";
        websiteData.value.website_chatbot_color = dbData.website_chatbot_color || "#111827";
        websiteData.value.website_chatbot_avtar = dbData.website_chatbot_avtar || "";
        websiteData.value.website_chatbot_msg = dbData.website_chatbot_msg || "Hi there! How can I help you today?";
        websiteData.value.website_chatbot_trianing_data = dbData.website_chatbot_trianing_data || '';

        websiteData.value.website_domain = dbData.website_domain || "";
        websiteData.value.website_domain_type = dbData.website_domain_type || "custom";
        websiteData.value.website_domain_dns = dbData.website_domain_dns || "";
        websiteData.value.website_domain_status = dbData.website_domain_status || "Pending";

        websiteData.value.website_auto_ssl = dbData.website_auto_ssl ?? true;
        websiteData.value.website_status = dbData.website_status || "Draft";

        websiteData.value.website_user = dbData.website_user || websiteData.value.website_user;
        websiteData.value.website_datetime = dbData.website_datetime || new Date().toISOString();

        mode.value = websiteData.value.website_mode.toString();
    

        console.log("✅ Website data manually populated from DB:", websiteData.value);
      }
    } catch (err) {
      console.error("⚠️ Error parsing website_db_data:", err);
    }
  }
  else{
  //    setTimeout(() => {
  //     showModeModal.value = false;
    
  // }, 1000);
  }
    await nextTick();
  });

const pricing = ref({
  layout: "",
  forms: [
    {
      title: "",
      price: "",
      desc: "",
      type: "Monthly",
      curr: "USD",
      status: "active",
      features: [""]
    },
    {
      title: "",
      price: "",
      desc: "",
      type: "Monthly",
      curr: "USD",
      status: "active",
      features: [""]
    },
    {
      title: "",
      price: "",
      desc: "",
      type: "Monthly",
      curr: "USD",
      status: "active",
      features: [""]
    }
  ]
});



const triggerFilePicker = () => {
  fileInput.value?.click();
};
const triggerFilePicker1 = () => {
  
  fileInput1.value?.click();
};

const chFile = async(e) => {
  const file = e?.target?.files?.[0];
  if (!file) return;

  if (file.size > 5 * 1024 * 1024) {
    alert("Max file size allowed is 5MB");
    e.target.value = "";
    return;
  }

   isLoading.value = true;
    const fd = new FormData();
    fd.append("file1", file);
    const res = await uploadFile(fd);
    isLoading.value = false;
    if (res.status) {
      websiteData.value.website_logo = res.file1;
      toast.success("Uploaded successfully");
    } else toast.error("Upload failed");
};

const chFile1 = async(e) => {
  const file = e?.target?.files?.[0];
  if (!file) return;

  if (file.size > 5 * 1024 * 1024) {
    alert("Max file size allowed is 5MB");
    e.target.value = "";
    return;
  }

   isLoading.value = true;
    const fd = new FormData();
    fd.append("file1", file);
    const res = await uploadFile(fd);
    isLoading.value = false;
    if (res.status) {
      websiteData.value.website_fav = res.file1;
      websiteData.value.website_chatbot_avtar = res.file1;
      toast.success("Uploaded successfully");
    } else toast.error("Upload failed");
};



// ✅ Unified Object (Matches `website_tbl` structure)
const websiteData = ref({
  website_id: "",
  website_title: "",
  website_mode: "",
  website_desc: "",
  website_seo_keyowrds:"",
  website_layout_category:"",
  website_layout_type:"",
  website_buss_name: "",
  website_buss_cat: "",
  website_buss_region: "",
  website_chatbot_trianing_data: "",
  website_buss_timezone:
    Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Kolkata",
  website_logo: "",
  website_fav: "",
  website_color: "#111827",
  website_seo_query: "",
  website_ai_description: "",
  website_seo_title: "",
  website_seo_desc: "",
  website_seo_keywords: [],
  website_new_keyword: "",
  website_seo_conical_url: "",
  website_seo_og_image: null,
  website_font: "Inter",
  website_layout: "",
  website_headline: "",
  website_subheadline: "",
  website_about_section: "",
  website_call_to_action: "",
  website_cta_link: "",
  website_promo_viedo: "",
  website_images: [],

  website_seo_graph_image: "",
  website_is_chatbot: true,
  website_chatbot_name: "July Toss Assistant",
  website_chatbot_color: "#111827",
  website_chatbot_avtar: "",
  website_chatbot_msg: "Hi there! How can I help you today?",
  website_domain: "",
  website_domain_type: "custom",
  website_domain_dns: "",
  website_domain_status: "Pending",
  
  website_auto_ssl: true,
  website_status: "Pending",
  plans:[],
  plan_layout:"",
  website_user:
    JSON.parse(sessionStorage.getItem("ldata") || "{}").user_id || "",
  website_datetime: new Date().toISOString(),
});



const publishWebsite = async () => {
  toast.success("🚀 Publishing your website...");
  try {
    isPublishing.value = true;

    // Debug: confirm data is ready
    websiteData.value.website_mode = mode.value;
    websiteData.value.website_status = "Pending";

    websiteData.value.plans = pricing.value.forms;
    websiteData.value.plan_layout  = pricing.value.layout;

    console.log("Publishing data:", websiteData.value);

    // ✅ Fix: remove `this`
    const res = await createWebsite(websiteData.value);

    if (res?.status) {
      toast.success(res?.success || "Website published successfully!");
      window.location.href = "/web_editor/"+res.website_dt.website_id;
    } else {
      toast.error(res?.error || "Failed to publish website. Try again.");
    }
  } catch (err) {
    console.error("KPI Error:", err);
    toast.error("An error occurred while publishing your website.");
  } finally {
    isPublishing.value = false;
  }
};




// === LAYOUT BUILDER VARIABLES ===
const layoutCategory = ref("");
const layoutType = ref("");
const selectedTemplate = ref(null);
const templates = ref([
  {
    id: "template1",
    name: "July Toss",
    desc: "A sleek portfolio layout perfect for creative agencies and freelancers.",
    category: "Agency",
    type: "One Page",
    image: "https://via.placeholder.com/400x250?text=July+Toss",
    aiRecommended: true,
  },
  {
    id: "template2",
    name: "Bold Agency",
    desc: "Clean, modern multipage design ideal for growing startups.",
    category: "Agency",
    type: "Multi Page",
    image: "https://via.placeholder.com/400x250?text=Bold+Agency",
    aiRecommended: false,
  },
  {
    id: "template3",
    name: "Cafe Delight",
    desc: "A warm, elegant template crafted for restaurants and cafes.",
    category: "Local Service",
    type: "One Page",
    image: "https://via.placeholder.com/400x250?text=Cafe+Delight",
    aiRecommended: true,
  },
  {
    id: "template4",
    name: "Marketify",
    desc: "A professional e-commerce landing page designed to convert visitors.",
    category: "E-Commerce",
    type: "Landing Page",
    image: "https://via.placeholder.com/400x250?text=Marketify",
    aiRecommended: false,
  },
  {
    id: "template5",
    name: "Freelance Pro",
    desc: "Showcase your work and attract clients with this smart, minimalist layout.",
    category: "Freelancer",
    type: "One Page",
    image: "https://via.placeholder.com/400x250?text=Freelance+Pro",
    aiRecommended: false,
  },
  {
    id: "template6",
    name: "ConsultIQ",
    desc: "Tailored for consultants with a clean, strategic look.",
    category: "Consulting",
    type: "Multi Page",
    image: "https://via.placeholder.com/400x250?text=ConsultIQ",
    aiRecommended: true,
  },
]);
const selectedColor = ref("#111827");

const presetColors = ref([
  "#111827", "#1E293B", "#334155", "#3B82F6", "#2563EB", "#1D4ED8",
  "#9333EA", "#7C3AED", "#C026D3", "#E11D48", "#DC2626", "#F97316",
  "#F59E0B", "#10B981", "#059669", "#14B8A6", "#06B6D4", "#0891B2",
  "#64748B", "#94A3B8", "#F3F4F6", "#9CA3AF",
]);

const colorName = computed(() => {
  const map = {
    "#111827": "Midnight Slate",
    "#1E293B": "Graphite",
    "#3B82F6": "Azure Blue",
    "#2563EB": "Royal Blue",
    "#9333EA": "Violet Spark",
    "#E11D48": "Crimson Red",
    "#F59E0B": "Sun Amber",
    "#10B981": "Mint Green",
    "#06B6D4": "Sky Aqua",
    "#94A3B8": "Frost Gray",
  };
  return map[selectedColor.value] || "Custom Shade";
});

const seoTitle = ref("");
const seoDescription = ref("");
const canonicalUrl = ref("");
const ogImage = ref(null);
const fileInput = ref(null);
const fileInput1 = ref(null);
const aiDescription = ref("");
const botName = ref("July Toss Assistant");
const botColor = ref("#111827");
const botAvatar = ref(null);
const botWelcome = ref("Hi there! How can I help you today?");

const avatarInput = ref(null);
const trainingInput = ref(null);

const selectedDomainType = ref("custom");
const customDomain = ref("");
const subdomain = ref("");
const enableSSL = ref(true);
const connectionVerified = ref(false);
const liveDomain = ref("");

const domainStatusMessage = ref("Awaiting verification...");
const domainStatusClass = computed(() => {
  if (domainStatusMessage.value.includes("connected")) return "status-success";
  if (domainStatusMessage.value.includes("error")) return "status-error";
  return "status-pending";
});
const domainStatusIcon = computed(() => {
  if (domainStatusMessage.value.includes("connected")) return "bx bx-check";
  if (domainStatusMessage.value.includes("error")) return "bx bx-error";
  return "bx bx-loader-circle bx-spin";
});

const verifyDomain = () => {
  domainStatusMessage.value = "Verifying...";
  setTimeout(() => {
    domainStatusMessage.value = "Domain successfully connected!";
    connectionVerified.value = true;
    liveDomain.value = `https://${customDomain.value}`;
  }, 2000);
};

// const reserveSubdomain = () => {
//   domainStatusMessage.value = "Reserving...";
//   setTimeout(() => {
//     domainStatusMessage.value = "Subdomain connected successfully!";
//     connectionVerified.value = true;
//     liveDomain.value = `https://${subdomain.value}.aiweb.app`;
//   }, 1500);
// };


const imageInput = ref(null);
const iconInput = ref(null);
const videoInput = ref(null);

const triggerFileUpload = (type) => {
  if (type === "images") imageInput.value.click();
  else if (type === "icons") iconInput.value.click();
  else if (type === "videos") videoInput.value.click();
  else if (type === "avatar") avatarInput.value.click();
  else if (type === "training") trainingInput.value.click();

};

// const removeFile = (type, index) => {
//   media.value[type].splice(index, 1);
// };

// === AI Generator Mock ===
const generateSEO = () => {
  aiDescription.value =
    "Empower your brand online with a fast, SEO-optimized, and professional website built by AI.";
  seoDescription.value = aiDescription.value;
};



const searchQuery = ref("");
const currentPage = ref(1);
const perPage = 6;

const filteredTemplates = computed(() => {
  return templates.value.filter((t) => {
    const matchesCategory = !layoutCategory.value || t.category === layoutCategory.value;
    const matchesType = !layoutType.value || t.type === layoutType.value;
    const matchesSearch =
      !searchQuery.value ||
      t.name.toLowerCase().includes(searchQuery.value.toLowerCase());
    return matchesCategory && matchesType && matchesSearch;
  });
});

const totalPages = computed(() => Math.ceil(filteredTemplates.value.length / perPage));

const paginatedTemplates = computed(() => {
  const start = (currentPage.value - 1) * perPage;
  return filteredTemplates.value.slice(start, start + perPage);
});



const triggerUpload = () => fileInput.value.click();
const handleFileUpload = async(event,type) => {
  const file = event.target.files[0];
  // if (file) ogImage.value = URL.createObjectURL(file);
   if (!file) return;
   isLoading.value = true;
    const fd = new FormData();
    
    if (type === "images"){
      fd.append("files_cnt", event.target.files.length+"");
      for(var x=0;x<event.target.files.length;x++){
        fd.append("file"+x, event.target.files[x]);
      }
    }
    else{
      fd.append("file1", file);
    }
    const res = await uploadFile(fd);
    isLoading.value = false;
    if (res.status) {
      
      if (type === "images") websiteData.value.website_images = res.files;
      else if (type === "videos") websiteData.value.website_promo_viedo = res.file1;
      else if (type === "avatar") websiteData.value.website_chatbot_avtar = res.file1;
      else if (type === "training") websiteData.value.website_chatbot_trianing_data = res.file1;

      toast.success("Uploaded successfully");
    } else toast.error("Upload failed");
};

const showModeModal = ref(false);
const mode = ref("detailed");
const currentStep = ref("business");
const businessName = ref("");

const isLoading = ref(false);
const content = ref({
  headline: "",
  subheadline: "",
  about: "",
  ctaText: "",
  ctaLink: "",
});

// ✅ Sync to unified object
watchEffect(() => {
  websiteData.value.website_buss_name = businessName.value;
  websiteData.value.website_color = selectedColor.value;
  websiteData.value.website_layout = selectedTemplate.value?.name || "";
  websiteData.value.website_headline = content.value.headline;
  websiteData.value.website_subheadline = content.value.subheadline;
  websiteData.value.website_about_section = content.value.about;
  websiteData.value.website_call_to_action = content.value.ctaText;
  websiteData.value.website_cta_link = content.value.ctaLink;
  websiteData.value.website_seo_title = seoTitle.value;
  websiteData.value.website_seo_desc = seoDescription.value;
  websiteData.value.website_seo_conical_url = canonicalUrl.value;
  websiteData.value.website_seo_graph_image = ogImage.value;
  websiteData.value.website_chatbot_name = botName.value;
  websiteData.value.website_chatbot_color = botColor.value;
  websiteData.value.website_chatbot_avtar = botAvatar.value;
  websiteData.value.website_chatbot_msg = botWelcome.value;
  websiteData.value.website_domain =
    selectedDomainType.value === "custom"
      ? customDomain.value
      : `${subdomain.value}.aiweb.app`;
  websiteData.value.website_domain_type = selectedDomainType.value;
  websiteData.value.website_auto_ssl = enableSSL.value;
});

const chkAt = () => {
  const domain = websiteData.value.website_domain?.trim();

  if (!domain) return "@";

  const parts = domain.split(".");

  if (parts.length === 2) {
    return "@";
  }
  return parts.slice(0, parts.length - 2).join(".");
};


const steps = [
  { id: "business", title: "Business Info", desc: "Basic details & tagline", icon: "bx bx-briefcase" },

  { id: "branding", title: "Branding", desc: "Logo, colors & typography", icon: "bx bx-brush" },

  // { id: "layout", title: "Layout", desc: "Choose template & layout", icon: "bx bx-grid-alt" },

  { id: "content", title: "Calendar", desc: "Fast, simple calendar booking tool", icon: "bx bx-calendar" },

  { id: "media", title: "Pricing", desc: "Your pricing plans", icon: "bx bx-dollar-circle" },

  { id: "chat", title: "Chat Bot", desc: "Setup your AI Bot", icon: "bx bx-message-dots" },

  { id: "domain", title: "Domain", desc: "Connect or choose subdomain", icon: "bx bx-link-alt" },

  { id: "publish", title: "Launch", desc: "Preview & go live", icon: "bx bx-rocket" },
];


const selectMode = (selected) => {
  
  mode.value = selected;
  showModeModal.value = false;
  currentStep.value = "business";
  
  nextTick(() => window.scrollTo({ top: 0, behavior: "smooth" }));
};

const stepOrder = computed(() => steps.map((s) => s.id));

const handleNext = () => {
  const wd = websiteData.value; // shorthand

  // 🔹 Instant Mode (Fast 3-step flow)
  if (mode.value === "instant") {
    if (currentStep.value === "business") {
      if (!wd.website_buss_name?.trim()){
        return toast.error("Please enter your business name.");
      }
      if (!wd.website_buss_cat?.trim()){
        return toast.error("Please enter your business category.");
      }
      if (!wd.website_about_section?.trim()){
        return toast.error("Please enter about your business.");
      }

      wd.website_status = "In Progress";

      currentStep.value = "branding";
      toast.success("Business info saved successfully!");
      nextTick(() => window.scrollTo({ top: 0, behavior: "smooth" }));
      return;
    }

    if (currentStep.value === "branding") {
      if (!wd.website_color)
        return toast.error("Please select a brand color to continue.");

      currentStep.value = "domain";
      toast.success("Branding details confirmed!");
      nextTick(() => window.scrollTo({ top: 0, behavior: "smooth" }));
      return;
    }

    if (currentStep.value === "domain") {
      // if (
      //   wd.website_domain_type === "custom" &&
      //   !wd.website_domain.match(/^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)
      // ) {
      //   return toast.error("Please enter a valid custom domain (e.g. mysite.com).");
      // }
      // if (
      //   wd.website_domain_type === "subdomain" &&
      //   !wd.website_domain?.trim()
      // ) {
      //   return toast.error("Please enter a subdomain name to continue.");
      // }

      if(!validateField(wd.website_domain,"domain",toast)){
        return;
      }

      wd.website_status = "Ready to Publish";
      toast.success("🎉 All steps completed successfully!");
      nextTick(() => window.scrollTo({ top: 0, behavior: "smooth" }));
      return;
    }
  }

  // 🔹 Detailed Mode (Full 9-step flow)
  else {
    // === Step 1: Business Info ===
    if (currentStep.value === "business") {
      if (!wd.website_buss_name?.trim())
        return toast.error("Please enter your business name.");

      if (!wd.website_buss_cat?.trim())
        return toast.warning("Please select a business category.");

      if (!wd.website_about_section?.trim())
        return toast.warning("Please enter your business details.");

      wd.website_status = "In Progress";
    }

    // === Step 2: Branding ===
    if (currentStep.value === "branding") {
      if (!wd.website_color)
        return toast.error("Please select a brand color.");
    }

    // === Step 3: Layout ===
    if (currentStep.value === "layout") {
      if (!wd.website_layout)
        return toast.error("Please choose a layout template before continuing.");
    }

    // === Step 4: Content ===
    // if (currentStep.value === "content") {
    //   if (!wd.website_headline?.trim())
    //     return toast.error("Please complete headline and call-to-action fields.");
    // }

    // === Step 5: Media ===
    if (currentStep.value === "media") {

      if (pricing.value.layout) {
        const activePlans = pricing.value.forms.slice(
          0,
          Number(pricing.value.layout)
        );
      
        for (let i = 0; i < activePlans.length; i++) {
          const plan = activePlans[i];
          const planNo = i + 1;

          if (!plan.title || !plan.title.trim()) {
            return toast.error(`Please enter title for Plan ${planNo}.`);
          }

          if (!plan.price || Number(plan.price) <= 0) {
            return toast.error(`Please enter a valid price for Plan ${planNo}.`);
          }

          if (!plan.desc || !plan.desc.trim()) {
            return toast.error(`Please enter description for Plan ${planNo}.`);
          }
        }
      }
    }


    // === Step 6: SEO ===
    if (currentStep.value === "seo") {
      if (!wd.website_seo_title?.trim() || !wd.website_seo_desc?.trim())
        return toast.warning("Please complete SEO title and description.");
    }

    // === Step 7: Chatbot ===
    if (currentStep.value === "chat") {
      // Already handled via form bindings
    }

    // === Step 8: Domain ===
    if (currentStep.value === "domain") {
      if (
        wd.website_domain_type === "custom" &&
        !wd.website_domain.match(/^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)
      ) {
        return toast.error("Please enter a valid custom domain (e.g. mysite.com).");
      }
      if (
        wd.website_domain_type === "subdomain" &&
        !wd.website_domain?.trim()
      ) {
        return toast.error("Please enter a subdomain name to continue.");
      }
    }

    // ✅ Step 9: Proceed to next
    const currentIndex = stepOrder.value.indexOf(currentStep.value);
    if (currentIndex < stepOrder.value.length - 1) {
      currentStep.value = stepOrder.value[currentIndex + 1];
      toast.success("Step completed successfully!");
      nextTick(() => window.scrollTo({ top: 0, behavior: "smooth" }));
    } else {
      wd.website_status = "Ready to Publish";
      toast.success("🎉 All steps completed successfully!");
    }
  }
};



const handleBack = () => {
  if (mode.value === "instant" && currentStep.value === "branding")
    currentStep.value = "business";
  else {
    const currentIndex = stepOrder.value.indexOf(currentStep.value);
    if (currentIndex > 0)
      currentStep.value = stepOrder.value[currentIndex - 1];
  }
};



const autosaveActive = ref(false);
const triggerAutosave = () => {
  autosaveActive.value = true;
  setTimeout(() => (autosaveActive.value = false), 2000);
};
watch(businessName, triggerAutosave);
</script>


<style scoped>
/* === Domain Enhancements === */
.loader-spinner {
  border: 3px solid #fff;
  border-top: 3px solid transparent;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 1s linear infinite;
  display: inline-block;
  vertical-align: middle;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.switch-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
}

.switch {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 22px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #d1d5db;
  transition: 0.4s;
  border-radius: 22px;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}
input:checked + .slider {
  background-color: #111827;
}
input:checked + .slider:before {
  transform: translateX(20px);
}

/* === Status === */
.domain-status {
  margin-left: 1rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.9rem;
}
.status-success {
  color: #10b981;
}
.status-error {
  color: #ef4444;
}
.status-pending {
  color: #6b7280;
}

/* === Connection Summary === */
.domain-summary {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1.5rem;
  margin-top: 2rem;
  text-align: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}
.domain-summary h4 {
  color: #10b981;
  font-weight: 600;
  margin-bottom: 0.4rem;
}
.live-domain {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.4rem;
  margin-top: 0.6rem;
}
.live-domain a {
  color: #111827;
  font-weight: 500;
  text-decoration: none;
}
.live-domain a:hover {
  text-decoration: underline;
}

/* === Responsive === */
@media (max-width: 768px) {
  .domain-status {
    margin-top: 0.6rem;
    margin-left: 0;
  }
  .verify-domain {
    flex-direction: column;
    gap: 0.6rem;
    align-items: flex-start;
  }
}

.chatbot-section {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1.8rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
}
.chatbot-section h4 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 1rem;
}

/* === Training File List === */
.training-files {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}
.training-file {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0.6rem 0.8rem;
  font-size: 0.9rem;
}
.training-file i {
  color: #111827;
}
.training-file .remove-btn {
  margin-left: auto;
  border: none;
  background: transparent;
  color: #ef4444;
  cursor: pointer;
  font-size: 1.1rem;
}

/* === Chat Preview === */
.chatbot-preview {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}
.chat-window {
  width: 100%;
  max-width: 380px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
}

/* Chat Header */
.chat-header {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  color: #fff;
  padding: 0.8rem 1rem;
}
.chat-header img {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
}

/* Messages */
.chat-messages {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 280px;
  overflow-y: auto;
}
.bot-message,
.user-message {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
}
.bot-message .avatar img {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}
.message {
  background: #fff;
  padding: 0.6rem 1rem;
  border-radius: 10px;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #111827;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.user-message {
  justify-content: flex-end;
}
.user-message .message {
  background: #111827;
  color: #fff;
  border-radius: 10px 10px 0 10px;
}

/* Chat Input */
.chat-input {
  display: flex;
  align-items: center;
  border-top: 1px solid #e5e7eb;
  background: #fff;
  padding: 0.6rem 0.8rem;
}
.chat-input input {
  flex: 1;
  border: none;
  font-size: 0.9rem;
  padding: 0.6rem;
  outline: none;
}
.chat-input button {
  border: none;
  border-radius: 8px;
  color: #fff;
  padding: 0.5rem 0.8rem;
  cursor: pointer;
  transition: all 0.3s ease;
}
.chat-input button:hover {
  opacity: 0.9;
}

/* Avatar Preview */
.bot-avatar-preview {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  object-fit: cover;
}

/* === Responsive === */
@media (max-width: 768px) {
  .chat-window {
    max-width: 100%;
  }
  .chatbot-section {
    padding: 1.2rem;
  }
}

.domain-options {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.domain-card {
  flex: 1 1 48%;
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1.2rem 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.domain-card i {
  font-size: 1.6rem;
  color: #111827;
  flex-shrink: 0;
  margin-top: 0.2rem;
}

.domain-card h4 {
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 0.2rem;
}

.domain-card p {
  color: #6b7280;
  font-size: 0.85rem;
  margin: 0;
  line-height: 1.4;
}

.domain-card:hover {
  background: #fff;
  border-color: #111827;
  transform: translateY(-3px);
  box-shadow: 0 4px 10px rgba(81, 69, 229, 0.1);
}

.domain-card.active {
  background: #fff;
  border-color: #111827;
  box-shadow: 0 0 0 3px rgba(81, 69, 229, 0.2);
}

/* === Domain Form === */
.domain-form {
  border: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 12px;
  padding: 1.8rem 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
}

.domain-form h5 {
  font-weight: 600;
  font-size: 1rem;
  color: #111827;
  margin-bottom: 0.4rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.domain-form .text-muted {
  color: #6b7280;
  font-size: 0.85rem;
  margin-bottom: 1rem;
}

.form-group label {
  font-weight: 600;
  color: #374151;
  font-size: 0.9rem;
  margin-bottom: 0.3rem;
  display: block;
}

.form-group input {
  width: 100%;
  border-radius: 10px;
  border: 1px solid #d1d5db;
  background: #f9fafb;
  padding: 0.8rem 1rem;
  font-size: 0.95rem;
  color: #111827;
  transition: all 0.25s ease;
}

.form-group input:focus {
  border-color: #111827;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(81, 69, 229, 0.15);
  outline: none;
}

/* === DNS Info Box === */
.dns-info {
  margin-top: 1.2rem;
  background: #f9fafb;
  border-radius: 10px;
  padding: 1rem 1.2rem;
  border: 1px solid #e5e7eb;
}

.dns-info h6 {
  font-weight: 600;
  color: #111827;
  font-size: 0.95rem;
  margin-bottom: 0.5rem;
}

.dns-info ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.dns-info li {
  color: #374151;
  font-size: 0.85rem;
  margin-bottom: 0.3rem;
}

/* === Subdomain Box === */
.subdomain-box {
  display: flex;
  align-items: center;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  overflow: hidden;
  background: #f9fafb;
}

.subdomain-box input {
  border: none;
  flex: 1;
  background: transparent;
  padding: 0.8rem 1rem;
  font-size: 0.95rem;
  color: #111827;
}

.subdomain-box span {
  background: #e5e7eb;
  color: #111827;
  padding: 0.8rem 1rem;
  font-size: 0.9rem;
  font-weight: 500;
  border-left: 1px solid #d1d5db;
}
.switch input:checked + .slider {
  background-color: #111827;
}
.switch .slider::before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}
.switch input:checked + .slider::before {
  transform: translateX(20px);
}

/* === Verify Button === */
.verify-domain {
  margin-top: 1.5rem;
  display: flex;
  justify-content: flex-end;
}

.verify-domain .btn-primary {
  background: #111827;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 0.8rem 1.6rem;
  font-size: 0.9rem;
  transition: all 0.25s ease;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.verify-domain .btn-primary:hover {
  background: #1f2937;
  transform: translateY(-2px);
}

/* === Animations === */
.fade-smooth-enter-active,
.fade-smooth-leave-active {
  transition: opacity 0.3s ease;
}
.fade-smooth-enter-from,
.fade-smooth-leave-to {
  opacity: 0;
}

/* === Responsive === */
@media (max-width: 768px) {
  .domain-card {
    flex: 1 1 100%;
  }

  .domain-form {
    padding: 1.5rem;
  }
}

.nk-content-wrap {
  background: #f9fafb;
  padding: 2.5rem 3rem;
  border-radius: 1rem;
  font-family: "Plus Jakarta Sans", sans-serif;
  color: #111827;
  animation: fadeIn 0.4s ease;
}

/* =========================================
   🔹 HEADER AREA
   ========================================= */
.page-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 0.3rem;
  letter-spacing: -0.02em;
}
.text-muted {
  color: #6b7280;
  font-size: 0.9rem;
}
.d-flex {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
.align-center {
  align-items: center;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 1rem;
}

/* Buttons */
.btn-primary,
.btn-outline-secondary {
  border-radius: 0.6rem;
  padding: 0.6rem 1.2rem;
  font-weight: 500;
  font-size: 0.9rem;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  transition: all 0.3s ease;
}
.btn-outline-secondary {
  border: 1px solid #d1d5db;
  background: #fff;
  color: #111827;
}
.btn-outline-secondary:hover {
  background: #111827;
  color: #fff;
}
.btn-primary {
  background: #111827;
  color: #fff;
  border: none;
}
.btn-primary:hover {
  background: #1f2937;
  transform: translateY(-2px);
}

/* =========================================
   🔹 MODE SELECTION
   ========================================= */
.mode-selection {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
}
.mode-card {
  flex: 1 1 48%;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 1rem;
  padding: 2rem 1.5rem;
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}
.mode-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}
.mode-card .icon-box {
  font-size: 2.5rem;
  color: #111827;
  margin-bottom: 0.8rem;
  transition: transform 0.3s ease;
}
.mode-card:hover .icon-box {
  transform: scale(1.1);
}
.mode-card h5 {
  font-weight: 600;
  font-size: 1.05rem;
  color: #111827;
  margin-bottom: 0.5rem;
}
.mode-card p {
  font-size: 0.9rem;
  color: #6b7280;
  line-height: 1.6;
  margin-bottom: 1rem;
}
.mode-card button {
  background: #111827;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 0.65rem 1.4rem;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}
.mode-card button:hover {
  background: #1f2937;
  transform: scale(1.04);
}
.mode-card.premium {
  border: 2px dashed #c7d2fe;
}
.badge-pro {
  background: #fcd34d;
  color: #111827;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.2rem 0.5rem;
  border-radius: 0.4rem;
  margin-left: 0.3rem;
}

/* =========================================
   🔹 MAIN SECTION LAYOUT
   ========================================= */
.main-section {
  display: flex;
  gap: 2.5rem;
  align-items: flex-start;
}

/* --- Sidebar --- */
.step-sidebar {
  width: 20rem;
  border-radius: 2rem;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 1rem;
  padding: 1.2rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  position: sticky;
  top: 100px;
  max-height: 80vh;
  overflow-y: auto;
  scroll-behavior: smooth;
}
.step-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.step-item {
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  padding: 0.75rem 0.9rem;
  border-radius: 10px;
  margin-bottom: 0.5rem;
  transition: all 0.25s ease;
  cursor: pointer;
}
.step-item:hover {
  background: #f3f4f6;
  transform: translateX(3px);
}
.step-item.active {
  background: rgba(81, 69, 229, 0.08);
  box-shadow: 0 0 0 2px rgba(81, 69, 229, 0.25);
}
.step-item .icon {
  font-size: 1.3rem;
  color: #111827;
  flex-shrink: 0;
  transition: transform 0.3s ease;
}
.step-item.active .icon {
  transform: scale(1.15) rotate(4deg);
}
.step-text h5 {
  font-size: 0.9rem;
  font-weight: 600;
  color: #111827;
  margin: 0;
}
.step-text p {
  font-size: 0.75rem;
  color: #6b7280;
  margin: 0;
}

/* --- Main Content --- */
.main-body {
  flex: 1;
  background: #fff;
  border-radius: 1rem;
  border: 1px solid #e5e7eb;
  padding: 2.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

/* =========================================
   🔹 FORM ELEMENTS
   ========================================= */
.section-title {
  font-size: 1.15rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 0.3rem;
}
.section-sub {
  color: #6b7280;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}
.form-label {
  font-weight: 600;
  font-size: 0.88rem;
  color: #374151;
  margin-bottom: 0.4rem;
  display: block;
}
.form-control {
  width: 100%;
  border-radius: 0.6rem;
  border: 1px solid #d1d5db;
  padding: 0.65rem 0.9rem;
  background: #f9fafb;
  font-size: 0.9rem;
  transition: all 0.25s ease;
}
.form-control:focus {
  border-color: #111827;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(81, 69, 229, 0.15);
  outline: none;
}

/* =========================================
   🔹 AI BUTTON & AUTOSAVE INDICATOR
   ========================================= */
.ai-btn {
  background: #111827;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.65rem 1.3rem;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  cursor: pointer;
}
.ai-btn:hover {
  background: #4338ca;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(81, 69, 229, 0.25);
}
.ai-btn i {
  animation: pulse 1.8s infinite;
}
.autosave-indicator {
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  color: #6b7280;
}
.autosave-dot {
  width: 6px;
  height: 6px;
  background: #10b981;
  border-radius: 50%;
  margin-right: 0.4rem;
  animation: pulse 1.5s infinite;
}

/* =========================================
   🔹 FOOTER NAVIGATION
   ========================================= */
.action-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  margin-top: 2.2rem;
}
.action-footer button {
  border: none;
  border-radius: 8px;
  padding: 0.65rem 1.4rem;
  font-weight: 500;
  font-size: 0.9rem;
  transition: all 0.25s ease;
  cursor: pointer;
}
.btn-secondary {
  background: #f3f4f6;
  color: #111827;
}
.btn-secondary:hover {
  background: #e5e7eb;
}
.btn-primary {
  background: #111827;
  color: #fff;
}
.btn-primary:hover {
  background: #1f2937;
  transform: translateY(-2px);
}

/* =========================================
   🔹 MODALS (MODE SELECTION & SAVE)
   ========================================= */
.mode-modal {
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  animation: fadeIn 0.3s ease;
}
.mode-modal-content {
  background: #fff;
  border-radius: 1.2rem;
  width: 100%;
  max-width: 540px;
  padding: 2rem;
  text-align: center;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  animation: slideUp 0.4s ease;
}
.mode-modal-content h3 {
  font-weight: 700;
  font-size: 1.4rem;
  color: #111827;
  margin-bottom: 0.4rem;
}
.mode-modal-content p {
  color: #6b7280;
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
}

/* =========================================
   🔹 ANIMATIONS
   ========================================= */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.35s ease;
}
.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(10px);
}
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* =========================================
   🔹 RESPONSIVE
   ========================================= */
@media (max-width: 1024px) {
  .main-section {
    flex-direction: column;
  }
  .step-sidebar {
    width: 100%;
    max-height: unset;
    order: 2;
  }
  .main-body {
    order: 1;
  }
}
@media (max-width: 768px) {
  .nk-content-wrap {
    padding: 1.5rem 1rem;
  }
  .page-title {
    font-size: 1.3rem;
  }
  .mode-card {
    flex: 1 1 100%;
  }
  .main-body {
    padding: 1.5rem;
  }
}

/* ===============================
   🔹 POPUP MODAL BASE
   =============================== */
.mode-modal {
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.6);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  animation: fadeIn 0.3s ease;
}

.mode-modal-content {
  background: #fff;
  border-radius: 1.2rem;
  width: 100%;
  max-width: 800px;
  padding: 2.2rem 2.5rem;
  text-align: center;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
  animation: slideUp 0.4s ease;
}

.mode-modal-content .modal-title {
  font-weight: 700;
  font-size: 1.4rem;
  color: #111827;
  margin-bottom: 0.4rem;
}

.mode-modal-content .modal-desc {
  color: #6b7280;
  font-size: 0.9rem;
  margin-bottom: 2rem;
}

/* ===============================
   🔹 HORIZONTAL CARD ALIGNMENT
   =============================== */
.mode-selection-horizontal {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 1.5rem;
}

.mode-card {
  flex: 1;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 1rem;
  padding: 1.8rem 1.5rem;
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  cursor: pointer;
}

.mode-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.mode-card .icon-box {
  font-size: 2.4rem;
  color: #111827;
  margin-bottom: 0.8rem;
  transition: transform 0.3s ease;
}

.mode-card:hover .icon-box {
  transform: scale(1.1);
}

.mode-card h5 {
  font-weight: 600;
  font-size: 1.05rem;
  color: #111827;
  margin-bottom: 0.5rem;
}

.mode-card p {
  font-size: 0.9rem;
  color: #6b7280;
  line-height: 1.5;
}

.mode-card.premium {
  border: 2px dashed #c7d2fe;
}

.badge-pro {
  background: #fcd34d;
  color: #111827;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.2rem 0.5rem;
  border-radius: 0.4rem;
  margin-left: 0.3rem;
}

/* ===============================
   🔹 ANIMATIONS
   =============================== */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===============================
   🔹 RESPONSIVE
   =============================== */
@media (max-width: 768px) {
  .mode-selection-horizontal {
    flex-direction: column;
    gap: 1rem;
  }

  .mode-card {
    padding: 1.5rem;
  }

  .mode-modal-content {
    padding: 1.5rem;
  }
}
/* === Step Body Container === */
.step-body {
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  padding: 2rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  animation: fadeInStep 0.4s ease;
}

/* === Headings === */
.step-body h3 {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.3rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 0.5rem;
}
.step-body .step-desc {
  color: #6b7280;
  font-size: 0.9rem;
  margin-bottom: 1.8rem;
}

/* === Form Grid === */
.form-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1.2rem;
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  flex: 1 1 100%;
}
.form-group.half {
  flex: 1 1 calc(50% - 0.6rem);
}

.form-group label {
  font-weight: 600;
  color: #374151;
  font-size: 0.9rem;
}

/* === Inputs & Selects === */
.form-group input,
.form-group select {
  width: 100%;
  border-radius: 10px;
  border: 1px solid #d1d5db;
  background: #f9fafb;
  padding: 0.8rem 1rem;
  font-size: 0.95rem;
  color: #111827;
  transition: all 0.25s ease;
}
.form-group input:focus,
.form-group select:focus {
  border-color: #111827;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(17, 24, 39, 0.1);
  outline: none;
}

/* === Upload Box === */
.upload-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border: 2px dashed #d1d5db;
  border-radius: 10px;
  padding: 1.5rem;
  background: #f9fafb;
  text-align: center;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.3s ease;
}
.upload-box:hover {
  background: #f3f4f6;
  border-color: #111827;
}
.upload-box i {
  font-size: 1.6rem;
  color: #111827;
}

/* === AI Button === */
.ai-btn {
  background: #111827;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.65rem 1.4rem;
  font-size: 0.9rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.25s ease;
  cursor: pointer;
}
.ai-btn:hover {
  background: #4338ca;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(81, 69, 229, 0.25);
}

/* === Autosave Indicator === */
.autosave-indicator {
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  color: #6b7280;
}
.autosave-dot {
  width: 6px;
  height: 6px;
  background: #10b981;
  border-radius: 50%;
  margin-right: 0.4rem;
  animation: pulse 1.5s infinite;
}

/* === Form Footer === */
.form-footer {
  display: flex;
  margin-top: 2rem;
}
.form-footer.between {
  justify-content: space-between;
  align-items: center;
}
.form-footer.end {
  justify-content: flex-end;
  gap: 1rem;
}

/* === Footer Buttons === */
.btn-primary,
.btn-secondary {
  border: none;
  border-radius: 10px;
  padding: 0.8rem 1.6rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.25s ease;
}
.btn-primary {
  background: #111827;
  color: #fff;
}
.btn-primary:hover {
  background: #1f2937;
  transform: translateY(-2px);
}
.btn-secondary {
  background: #f3f4f6;
  color: #111827;
}
.btn-secondary:hover {
  background: #e5e7eb;
}

/* === Animations === */
@keyframes fadeInStep {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* === Responsive === */
@media (max-width: 768px) {
  .form-group.half {
    flex: 1 1 100%;
  }
  .form-footer {
    flex-direction: column;
    gap: 1rem;
  }
}

/* === Layout Step Styling === */
.layout-filters {
  display: flex;
  gap: 1.2rem;
  flex-wrap: wrap;
  margin-bottom: 1.5rem;
}

.template-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.5rem;
}

.template-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  position: relative;
}
.template-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}
.template-card.active {
  border: 2px solid #111827;
  box-shadow: 0 0 0 4px rgba(17, 24, 39, 0.15);
}

.template-thumb {
  position: relative;
  height: 160px;
  background: #f9fafb;
  display: flex;
  align-items: center;
  justify-content: center;
}
.template-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-bottom: 1px solid #e5e7eb;
}

.ai-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #111827;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0.3rem 0.6rem;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
  box-shadow: 0 2px 8px rgba(81, 69, 229, 0.3);
}

.template-info {
  padding: 1rem;
  text-align: left;
}
.template-info h4 {
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 0.3rem;
}
.template-info p {
  color: #6b7280;
  font-size: 0.85rem;
  line-height: 1.4;
}

/* === Live Preview === */
.template-preview {
  margin-top: 2rem;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1.2rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
.template-preview h4 {
  font-weight: 600;
  color: #111827;
  margin-bottom: 0.8rem;
}
.preview-frame {
  width: 100%;
  height: 400px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: #fafafa;
}

/* === Responsive === */
@media (max-width: 768px) {
  .layout-filters {
    flex-direction: column;
  }
  .preview-frame {
    height: 300px;
  }
}

/* === Content Step === */
.ai-section {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 2rem;
}
.ai-header {
  margin-bottom: 1rem;
}
.ai-header h4 {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  color: #111827;
  font-size: 1.05rem;
}
.ai-header p {
  color: #6b7280;
  font-size: 0.9rem;
  margin-top: 0.3rem;
}

/* === AI Input Row === */
.ai-input-row {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}
.ai-input-row input {
  flex: 1;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 0.9rem 1rem;
  background: #fff;
  font-size: 0.9rem;
  transition: all 0.25s ease;
}
.ai-input-row input:focus {
  border-color: #111827;
  box-shadow: 0 0 0 3px rgba(81, 69, 229, 0.15);
  outline: none;
}
.btn-ai-generate {
  background: #111827;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 0.8rem 1.4rem;
  font-weight: 500;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.25s ease;
}
.btn-ai-generate:hover {
  background: #4338ca;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(81, 69, 229, 0.25);
}

/* === AI Loading Animation === */
.ai-loading {
  margin-top: 1.2rem;
  display: flex;
  align-items: center;
  gap: 0.8rem;
  color: #111827;
  font-weight: 500;
  font-size: 0.9rem;
}
.loader {
  width: 20px;
  height: 20px;
  border: 3px solid #d1d5db;
  border-top: 3px solid #111827;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* === Content Editor === */
.content-editor {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1.8rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.content-editor .form-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1.2rem;
  margin-bottom: 2rem;
}
.content-editor .form-group.full {
  flex: 1 1 100%;
}
.content-editor .form-group.half {
  flex: 1 1 calc(50% - 0.6rem);
}
.content-editor label {
  font-weight: 600;
  font-size: 0.9rem;
  color: #374151;
  margin-bottom: 0.4rem;
}
.content-editor input,
.content-editor textarea {
  width: 100%;
  border-radius: 10px;
  border: 1px solid #d1d5db;
  background: #f9fafb;
  padding: 0.8rem 1rem;
  font-size: 0.95rem;
  color: #111827;
  transition: all 0.25s ease;
}
.content-editor input:focus,
.content-editor textarea:focus {
  border-color: #111827;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(17, 24, 39, 0.1);
  outline: none;
}

/* === Live Preview === */
.preview-box {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1.5rem;
}
.preview-box h4 {
  font-weight: 600;
  color: #111827;
  margin-bottom: 1rem;
}
.preview-content {
  text-align: center;
  background: #fff;
  padding: 2rem 1.5rem;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}
.preview-content h2 {
  font-size: 1.4rem;
  color: #111827;
  font-weight: 700;
  margin-bottom: 0.5rem;
}
.preview-content p {
  color: #6b7280;
  font-size: 0.9rem;
  margin-bottom: 1.2rem;
}
.btn-preview {
  background: #111827;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.7rem 1.4rem;
  font-weight: 500;
  transition: all 0.25s ease;
}
.btn-preview:hover {
  background: #1f2937;
  transform: translateY(-2px);
}

/* === Responsive === */
@media (max-width: 768px) {
  .ai-input-row {
    flex-direction: column;
  }
  .content-editor .form-group.half {
    flex: 1 1 100%;
  }
}

/* === SEO Tab Container === */
.step-body {
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  padding: 2rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  animation: fadeInStep 0.4s ease;
}

/* === Header === */
.step-body h3 {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.3rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 0.5rem;
}

.step-body .step-desc {
  color: #6b7280;
  font-size: 0.9rem;
  margin-bottom: 1.8rem;
}

/* === AI SEO Generator === */
.ai-seo-box {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  transition: all 0.3s ease;
}
.ai-seo-box:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
}

.ai-seo-header h4 {
  font-size: 1.05rem;
  color: #111827;
  font-weight: 600;
  margin-bottom: 0.3rem;
  display: flex;
  align-items: center;
  gap: 6px;
}

.ai-seo-header p {
  color: #6b7280;
  font-size: 0.85rem;
  margin-bottom: 1rem;
}

.ai-input-row {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.ai-input-row input {
  flex: 1;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 0.8rem 1rem;
  background: #fff;
  font-size: 0.95rem;
  transition: all 0.25s ease;
}
.ai-input-row input:focus {
  border-color: #111827;
  box-shadow: 0 0 0 3px rgba(81, 69, 229, 0.15);
  outline: none;
}

.btn-ai-generate {
  background: #111827;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 0.75rem 1.4rem;
  font-weight: 500;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}
.btn-ai-generate:hover {
  background: #4338ca;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(81, 69, 229, 0.25);
}

/* === AI Output === */
.ai-output {
  margin-top: 1rem;
  background: #eef2ff;
  border-radius: 10px;
  padding: 1rem;
  font-size: 0.9rem;
  color: #4338ca;
  border: 1px solid #c7d2fe;
  animation: fadeInStep 0.3s ease;
}

/* === SEO Meta Form === */
.seo-meta-form {
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
  margin-bottom: 2rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.form-group label {
  font-weight: 600;
  font-size: 0.9rem;
  color: #374151;
}

.form-group input,
.form-group textarea,
.form-group select {
  width: 100%;
  border-radius: 10px;
  border: 1px solid #d1d5db;
  background: #f9fafb;
  padding: 0.8rem 1rem;
  font-size: 0.95rem;
  color: #111827;
  transition: all 0.25s ease;
}
.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
  border-color: #111827;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(81, 69, 229, 0.1);
  outline: none;
}

/* === Keywords List === */
.keyword-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
}
.keyword-tag {
  background: #eef2ff;
  color: #111827;
  padding: 0.4rem 0.8rem;
  border-radius: 8px;
  font-size: 0.85rem;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: default;
}
.keyword-tag i {
  font-size: 1rem;
  cursor: pointer;
  transition: color 0.2s ease;
}
.keyword-tag i:hover {
  color: #dc2626;
}

/* === Upload Box (OG Image) === */
.upload-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border: 2px dashed #d1d5db;
  border-radius: 10px;
  padding: 1.5rem;
  background: #f9fafb;
  text-align: center;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.3s ease;
}
.upload-box:hover {
  background: #f3f4f6;
  border-color: #111827;
}
.upload-box i {
  font-size: 1.6rem;
  color: #111827;
}
.preview-image {
  width: 100%;
  max-width: 240px;
  border-radius: 10px;
  margin-top: 0.8rem;
}

/* === SEO Health Summary === */
.seo-health {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
}
.seo-health h4 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1.05rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 0.8rem;
}
.seo-checklist {
  list-style: none;
  padding: 0;
  margin: 0;
}
.seo-checklist li {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0.5rem 0;
  color: #6b7280;
  font-size: 0.9rem;
  transition: all 0.25s ease;
}
.seo-checklist li.success {
  color: #10b981;
  font-weight: 500;
}
.seo-checklist li i {
  font-size: 1rem;
}

/* === Transitions === */
.fade-smooth-enter-active,
.fade-smooth-leave-active {
  transition: opacity 0.3s ease;
}
.fade-smooth-enter-from,
.fade-smooth-leave-to {
  opacity: 0;
}

/* === Animations === */
@keyframes fadeInStep {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* === Responsive === */
@media (max-width: 768px) {
  .ai-input-row {
    flex-direction: column;
    gap: 0.8rem;
  }
  .btn-ai-generate {
    width: 100%;
  }
  .upload-box {
    padding: 1rem;
  }
  .seo-health {
    padding: 1.2rem;
  }
}

/* =========================================
   🎞️ MEDIA TAB STYLES
   ========================================= */
.media-section {
  margin-bottom: 2.5rem;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1.8rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
}

.media-section:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
}

.media-section h4 {
  font-size: 1.05rem;
  font-weight: 600;
  color: #111827;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.4rem;
}

.media-section h4 i {
  color: #111827;
  font-size: 1.2rem;
}

.media-sub {
  color: #6b7280;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

/* =========================================
   📤 UPLOAD BOX
   ========================================= */
.upload-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #d1d5db;
  border-radius: 12px;
  padding: 2rem;
  background: #f9fafb;
  text-align: center;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.3s ease;
}

.upload-box:hover {
  background: #f3f4f6;
  border-color: #111827;
  transform: translateY(-2px);
}

.upload-box i {
  font-size: 2.2rem;
  color: #111827;
  margin-bottom: 0.6rem;
  transition: transform 0.3s ease;
}

.upload-box:hover i {
  transform: scale(1.1);
}

.upload-box span {
  font-size: 0.9rem;
  color: #6b7280;
}

/* =========================================
   🖼️ PREVIEW GRID
   ========================================= */
.preview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 1rem;
  margin-top: 1.5rem;
}

.preview-card {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

.preview-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.08);
}

.preview-card img {
  width: 100%;
  height: 120px;
  object-fit: cover;
  display: block;
  border-radius: 10px;
}

/* Small icon previews */
.preview-card.small img {
  height: 80px;
  padding: 10px;
  object-fit: contain;
  background: #fff;
}

/* Remove Button */
.remove-btn {
  position: absolute;
  top: 6px;
  right: 6px;
  background: rgba(17, 24, 39, 0.8);
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s ease;
}

.preview-card:hover .remove-btn {
  opacity: 1;
  transform: scale(1.05);
}

.remove-btn:hover {
  background: #ef4444;
}

/* =========================================
   🎬 VIDEO PREVIEW
   ========================================= */
.video-preview {
  position: relative;
  margin-top: 1.5rem;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  background: #000;
}

.video-preview video {
  width: 100%;
  border-radius: 12px;
  display: block;
}

.remove-btn.video {
  position: absolute;
  bottom: 12px;
  right: 12px;
  background: rgba(17, 24, 39, 0.85);
  border-radius: 6px;
  padding: 0.5rem 0.8rem;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.85rem;
  transition: all 0.3s ease;
}

.remove-btn.video:hover {
  background: #ef4444;
  transform: scale(1.05);
}

/* =========================================
   ✨ ANIMATIONS
   ========================================= */
.fade-smooth-enter-active,
.fade-smooth-leave-active {
  transition: opacity 0.3s ease;
}

.fade-smooth-enter-from,
.fade-smooth-leave-to {
  opacity: 0;
}

/* =========================================
   📱 RESPONSIVE DESIGN
   ========================================= */
@media (max-width: 768px) {
  .media-section {
    padding: 1.4rem;
  }

  .upload-box {
    padding: 1.5rem;
  }

  .preview-grid {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 0.8rem;
  }

  .preview-card img {
    height: 100px;
  }
}

@media (max-width: 480px) {
  .media-section h4 {
    font-size: 1rem;
  }

  .media-sub {
    font-size: 0.85rem;
  }

  .upload-box span {
    font-size: 0.85rem;
  }
}
/* =========================================
   🚀 LAUNCH TAB
   ========================================= */

/* === Summary Section === */
.launch-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.launch-card {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1.2rem 1rem;
  transition: all 0.3s ease;
}

.launch-card:hover {
  background: #fff;
  border-color: #111827;
  box-shadow: 0 4px 12px rgba(81, 69, 229, 0.08);
  transform: translateY(-3px);
}

.launch-card i {
  font-size: 1.8rem;
  color: #111827;
  flex-shrink: 0;
  margin-top: 0.2rem;
}

.launch-card h4 {
  font-weight: 600;
  font-size: 1rem;
  color: #111827;
  margin-bottom: 0.4rem;
}

.launch-card ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.launch-card li {
  font-size: 0.85rem;
  color: #374151;
  margin-bottom: 0.3rem;
}

/* === Preview Section === */
.preview-section {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.preview-header h4 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
}

.preview-header .btn-outline-primary {
  border: 1px solid #111827;
  background: transparent;
  color: #111827;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.25s ease;
}

.preview-header .btn-outline-primary:hover {
  background: #111827;
  color: #fff;
}

.preview-frame {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  height: 340px;
}

.preview-frame iframe {
  width: 100%;
  height: 100%;
  border: none;
  background: #f9fafb;
}

.preview-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(249, 250, 251, 0.85);
  color: #6b7280;
  font-size: 0.9rem;
  font-weight: 500;
}

/* === Launch Actions === */
.launch-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
}

.btn-primary.launch-btn {
  background: #111827;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 0.8rem 1.6rem;
  font-size: 0.95rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
}

.btn-primary.launch-btn:hover {
  background: #4338ca;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(81, 69, 229, 0.25);
}

/* === Smooth Animations === */
.fade-smooth-enter-active,
.fade-smooth-leave-active {
  transition: opacity 0.3s ease;
}
.fade-smooth-enter-from,
.fade-smooth-leave-to {
  opacity: 0;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* === Responsive === */
@media (max-width: 768px) {
  .launch-summary {
    grid-template-columns: 1fr;
  }
  .preview-frame {
    height: 260px;
  }
  .launch-actions {
    flex-direction: column;
  }
  .btn-primary.launch-btn,
  .btn-secondary {
    width: 100%;
    justify-content: center;
  }
}
/* === Layout Filters Bar === */
.layout-filters-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 1rem;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1rem 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  margin-bottom: 1.8rem;
  animation: fadeIn 0.4s ease;
}
.search-box {
  display: flex;
  align-items: center;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 0.5rem 0.8rem;
  flex: 1;
  background: #f9fafb;
  transition: all 0.3s ease;
}
.search-box:focus-within {
  border-color: #111827;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(17, 24, 39, 0.1);
}
.search-box i {
  color: #6b7280;
  font-size: 1.2rem;
}
.search-box input {
  border: none;
  background: transparent;
  outline: none;
  flex: 1;
  padding: 0 0.5rem;
  font-size: 0.9rem;
  color: #111827;
}

/* === Template Grid === */
.template-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
}
.template-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 1rem;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  animation: fadeIn 0.4s ease;
}
.template-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.08);
}
.template-card.active {
  border: 2px solid #111827;
  box-shadow: 0 0 0 4px rgba(17, 24, 39, 0.15);
}
.template-thumb {
  position: relative;
  height: 180px;
  background: #f9fafb;
}
.template-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.ai-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #111827;
  color: #fff;
  font-size: 0.75rem;
  padding: 0.3rem 0.6rem;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
}

/* === Pagination === */
.pagination-bar {
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}
.page-btn {
  background: #f3f4f6;
  border: none;
  color: #111827;
  padding: 0.6rem 1rem;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
}
.page-btn:hover:not(:disabled) {
  background: #111827;
  color: #fff;
}
.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.page-info {
  font-size: 0.9rem;
  color: #374151;
}

/* === Animations === */
@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-4px); }
}
.animate-bounce {
  animation: bounce 1.8s infinite;
}

/* === Responsive === */
@media (max-width: 1024px) {
  .template-grid {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  }
}
@media (max-width: 768px) {
  .layout-filters-bar {
    flex-direction: column;
  }
  .template-grid {
    grid-template-columns: 1fr;
  }
  .pagination-bar {
    flex-direction: column;
  }
}
.color-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 1.4rem 1.2rem;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.color-card:hover {
  transform: translateY(-3px);
  border-color: #111827;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.08);
}

/* === Header === */
.color-header {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.color-preview {
  position: relative;
  width: 56px;
  height: 56px;
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s ease;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.color-preview i {
  font-size: 1.4rem;
  color: #ffffff;
  opacity: 0.9;
  pointer-events: none;
}

.color-preview:hover {
  transform: scale(1.05);
}

.color-input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

.color-meta h5 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
}

.color-meta span {
  font-size: 0.85rem;
  color: #6b7280;
  font-family: monospace;
}

/* === Palette === */
.color-palette {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.4rem;
}

.color-swatch {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px solid #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.color-swatch:hover {
  transform: scale(1.1);
  border-color: #111827;
}

/* === Animations === */
.animate-fadein {
  animation: fadeIn 0.4s ease;
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

/* === Responsive === */
@media (max-width: 768px) {
  .color-card {
    padding: 1rem;
  }
  .color-preview {
    width: 48px;
    height: 48px;
  }
  .color-swatch {
    width: 26px;
    height: 26px;
  }
}
/* =========================================
   📱 FINAL MOBILE SIDEBAR + FORM SPACING FIX
   ========================================= */

@media (max-width: 1024px) {
  /* Sidebar above content */
  .main-section {
    flex-direction: column !important;
  }
  .step-sidebar {
    order: 1 !important;
    width: 100% !important;
    position: relative !important;
    top: auto !important;
    max-height: unset !important;
    margin-bottom: 1.2rem !important;
  }
  .main-body {
    order: 2 !important;
    width: 100% !important;
  }
}

@media (max-width: 768px) {
  /* Reduce padding for compact mobile layout */
  .nk-content-wrap {
    padding: 1rem 0.8rem !important;
  }

  .main-body {
    padding: 1rem !important;
  }

  /* Sidebar scroll fix */
  .step-sidebar {
    padding: 0.8rem !important;
    box-shadow: none !important;
    border: 1px solid #e5e7eb !important;
    background: #fff !important;
  }

  /* Horizontal scroll for tabs */
  .step-list {
    display: flex !important;
    overflow-x: auto !important;
    flex-wrap: nowrap !important;
    gap: 0.8rem !important;
    padding-bottom: 0.5rem !important;
    scrollbar-width: thin;
    scrollbar-color: #d1d5db transparent;
  }
  .step-list::-webkit-scrollbar {
    height: 6px;
  }
  .step-list::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 4px;
  }
  .step-item {
    flex: 0 0 auto !important;
    min-width: 130px !important;
    text-align: center !important;
    padding: 0.6rem 0.5rem !important;
    border-radius: 8px !important;
  }
  .step-item.active {
    background: rgba(17, 24, 39, 0.1) !important;
  }
  .step-item .step-text h5 {
    font-size: 0.8rem !important;
  }
  .step-item .step-text p {
    display: none !important;
  }

  /* === FORM BOTTOM SPACING FIX === */
  form,
  .form-grid,
  .content-editor,
  .ai-section,
  .seo-meta-form,
  .media-section,
  .domain-form {
    margin-bottom: 2.5rem !important;
  }

  /* Ensure inputs aren’t touching screen edges */
  .form-group input,
  .form-group select,
  .form-group textarea {
    width: 100% !important;
  }

  /* Adjust buttons for mobile */
  .btn-primary,
  .btn-secondary,
  .btn-outline-secondary {
    padding: 0.55rem 1rem !important;
    font-size: 0.85rem !important;
  }

  .form-footer,
  .action-footer {
    margin-bottom: 1.5rem !important;
  }

  /* Fix iframe preview height */
  .preview-frame {
    height: 260px !important;
  }
}

@media (max-width: 480px) {
  /* Compact layout for very small devices */
  .nk-content-wrap {
    padding: 0.8rem 0.6rem !important;
  }

  .main-body {
    padding: 0.8rem !important;
  }

  .step-sidebar {
    padding: 0.6rem !important;
  }

  .step-item {
    min-width: 110px !important;
  }

  .page-title {
    font-size: 1.1rem !important;
  }

  /* Form bottom spacing */
  form,
  .form-grid,
  .content-editor,
  .media-section {
    margin-bottom: 2rem !important;
  }

  .btn-primary,
  .btn-secondary {
    width: 100% !important;
  }
}
 .calendar-frame {
            display: flex;
            justify-content: center;
        }

        .calendar-iframe {
            width: 100%;
            height: 75vh;
            border: none;
            border-radius: 22px;
            background: white;
        }

        /* Mobile Fix */
        @media(max-width:768px) {
            .calendar-iframe {
                height: 65vh;
            }
        }

        /* ================================
   PRICING PLANS (WIZARD)
================================ */

/* Main Wrapper */
.pricing-plans-wrapper {
  margin-top: 20px;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

/* Plan Box */
.pricing-plan-box {
  flex: 1;
  min-width: 260px;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 18px 16px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.05);
  transition: 0.25s ease;
}

.pricing-plan-box:hover {
  border-color: var(--primary);
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
}

/* Plan Title */
.pricing-plan-box h4 {
  margin-bottom: 14px;
  font-size: 1rem;
  font-weight: 700;
  color: var(--text);
}

/* Form Group */
.pricing-plan-box .form-group {
  margin-bottom: 14px;
}

.pricing-plan-box label {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
  color: var(--muted);
}

.pricing-plan-box input,
.pricing-plan-box select,
.pricing-plan-box textarea {
  width: 100%;
  border-radius: 6px;
  border: 1px solid var(--border);
  background: var(--card);
  color: var(--text);
  padding: 8px 10px;
  font-size: 13px;
  transition: 0.25s border ease;
}

.pricing-plan-box input:focus,
.pricing-plan-box select:focus,
.pricing-plan-box textarea:focus {
  border-color: var(--primary);
}

/* Features List */
.features-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.feature-item {
  display: flex;
  gap: 8px;
  align-items: center;
}

.feature-item input {
  flex: 1;
}

/* Add Feature */
.btn-add-feature {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #eef2ff;
  color: var(--primary);
  border: none;
  padding: 7px 12px;
  font-size: 13px;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 6px;
  transition: 0.25s ease;
}

.btn-add-feature:hover {
  background: var(--primary);
  color: #fff;
}

/* Remove Feature Button */
.btn-delete-sm {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background: #fee2e2;
  color: #991b1b;
  border: none;
  cursor: pointer;
  transition: 0.25s ease;
}

.btn-delete-sm:hover {
  background: #dc2626;
  color: white;
}

/* Save Button (CTA) */
.btn-save-pricing {
  margin-top: 22px;
  width: 100%;
  padding: 10px 14px;
  background: var(--primary);
  color: #fff;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
}

.btn-save-pricing:hover {
  opacity: 0.9;
}

/* =====================
   Smooth Fade Animation
===================== */
.fade-in {
  animation: fadeIn 0.35s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===========================
   RESPONSIVE ADJUSTMENTS
=========================== */

/* Tablet */
@media (max-width: 900px) {
  .pricing-plans-wrapper {
    flex-direction: column;
  }
}

/* Mobile */
@media (max-width: 600px) {
  .pricing-plan-box {
    padding: 14px;
  }

  .btn-add-feature {
    width: 100%;
    justify-content: center;
  }
}
/* ============================================
   PRICING PLANS – COMPLETE STYLE PACK
   ============================================ */

/* Wrapper for all plans */
.plans-builder {
  display: flex;
  gap: 20px;
  margin-top: 20px;
}

/* Layout variants (number of columns) */
.plans-builder.layout-1 {
  flex-direction: column;
}

.plans-builder.layout-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.plans-builder.layout-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

/* Individual plan box container */
.plan-box {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 18px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.05);
  transition: 0.25s ease;
}

.plan-box:hover {
  border-color: var(--primary);
  box-shadow: 0 3px 12px rgba(0,0,0,0.08);
}

/* Plan Title */
.plan-box h4 {
  margin-bottom: 14px;
  font-size: 1rem;
  font-weight: 700;
  color: var(--text);
}

/* Form items */
.plan-box .form-group {
  margin-bottom: 14px;
}

.plan-box label {
  font-size: 13px;
  font-weight: 600;
  color: var(--muted);
  margin-bottom: 6px;
  display: block;
}

/* Inputs */
.plan-box input,
.plan-box select,
.plan-box textarea {
  width: 100%;
  padding: 8px 10px;
  font-size: 13px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--card);
  color: var(--text);
  outline: none;
  transition: 0.25s ease;
}

.plan-box input:focus,
.plan-box select:focus,
.plan-box textarea:focus {
  border-color: var(--primary);
}

/* Features List */
.features-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.feature-item {
  display: flex;
  gap: 8px;
  align-items: center;
}

.feature-item input {
  flex: 1;
}

/* Add Feature Button */
.btn-add-feature {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  padding: 7px 12px;
  background: #eef2ff;
  color: var(--primary);
  border: none;
  font-size: 13px;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.25s ease;
}

.btn-add-feature:hover {
  background: var(--primary);
  color: #fff;
}

/* Delete Feature Button */
.btn-delete-sm {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  border: none;
  background: #fee2e2;
  color: #991b1b;
  cursor: pointer;
  transition: 0.25s ease;
}

.btn-delete-sm:hover {
  background: #dc2626;
  color: white;
}

/* Submit Button Fix */
.btn-create {
  background: var(--primary);
  color: #fff;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 25px;
  transition: 0.3s ease;
}

.btn-create:hover {
  opacity: 0.9;
}

/* Smooth Fade Animation */
.fade-smooth-enter-active,
.fade-smooth-leave-active {
  transition: all 0.3s ease;
}

.fade-smooth-enter-from,
.fade-smooth-leave-to {
  opacity: 0;
  transform: translateY(5px);
}

/* ============================================
   RESPONSIVE BEHAVIOR
   ============================================ */

/* Tablet */
@media (max-width: 1024px) {
  .plans-builder.layout-3 {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mobile */
@media (max-width: 768px) {
  .plans-builder,
  .plans-builder.layout-2,
  .plans-builder.layout-3 {
    display: flex;
    flex-direction: column;
  }

  .plan-box {
    margin-bottom: 18px;
  }

  .btn-add-feature {
    width: 100%;
    justify-content: center;
  }
}

/* Small Mobile */
@media (max-width: 480px) {
  .plan-box {
    padding: 14px;
  }

  .plan-box h4 {
    font-size: 0.95rem;
  }

  .btn-delete-sm {
    width: 24px;
    height: 24px;
  }
}

</style>


